// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/admin.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { OrganizationFeature } from "./organizations_pb";
import { file_cortado_v1_organizations } from "./organizations_pb";
import type { AgentModelProviderEnum, AiOrbStateConfigs, EmailMarketingAudienceEnum, EmailMarketingCampaignStatusEnum, EmailMarketingChannelEnum, EmailMarketingResourceTypeEnum, FeedbackStageEnum, OrganizationFeatureEnum, OrganizationFeatureStageEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { ArchiveAnnouncementRequestSchema, ArchiveAnnouncementResponseSchema, CreateAnnouncementRequestSchema, CreateAnnouncementResponseSchema, ListAnnouncementReadsRequestSchema, ListAnnouncementReadsResponseSchema, ListAnnouncementsRequestSchema, ListAnnouncementsResponseSchema } from "./announcements_pb";
import { file_cortado_v1_announcements } from "./announcements_pb";
import type { BillingAccessStateEnum, BillingIntervalEnum, OrganizationBillingState, PlanKeyEnum } from "./subscriptions_pb";
import { file_cortado_v1_subscriptions } from "./subscriptions_pb";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/admin.proto.
 */
export const file_cortado_v1_admin: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_users, file_cortado_v1_organizations, file_cortado_v1_settings, file_cortado_v1_announcements, file_cortado_v1_subscriptions, file_google_protobuf_timestamp, file_google_protobuf_field_mask]);

/**
 * Admin represents an admin user
 *
 * @generated from message cortado.v1.Admin
 */
export type Admin = Message<"cortado.v1.Admin"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string created_by = 6;
   */
  createdBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 8;
   */
  updatedBy?: string;
};

/**
 * Describes the message cortado.v1.Admin.
 * Use `create(AdminSchema)` to create a new message.
 */
export const AdminSchema: GenMessage<Admin> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 0);

/**
 * VerifyAdminRequest is sent after Supabase login to verify admin status
 *
 * @generated from message cortado.v1.VerifyAdminRequest
 */
export type VerifyAdminRequest = Message<"cortado.v1.VerifyAdminRequest"> & {
};

/**
 * Describes the message cortado.v1.VerifyAdminRequest.
 * Use `create(VerifyAdminRequestSchema)` to create a new message.
 */
export const VerifyAdminRequestSchema: GenMessage<VerifyAdminRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 1);

/**
 * VerifyAdminResponse returns admin data if the user is an admin
 *
 * @generated from message cortado.v1.VerifyAdminResponse
 */
export type VerifyAdminResponse = Message<"cortado.v1.VerifyAdminResponse"> & {
  /**
   * @generated from field: cortado.v1.Admin admin = 1;
   */
  admin?: Admin;

  /**
   * @generated from field: cortado.v1.User user = 2;
   */
  user?: User;
};

/**
 * Describes the message cortado.v1.VerifyAdminResponse.
 * Use `create(VerifyAdminResponseSchema)` to create a new message.
 */
export const VerifyAdminResponseSchema: GenMessage<VerifyAdminResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 2);

/**
 * ListAdminsRequest requests all admin users
 *
 * @generated from message cortado.v1.ListAdminsRequest
 */
export type ListAdminsRequest = Message<"cortado.v1.ListAdminsRequest"> & {
};

/**
 * Describes the message cortado.v1.ListAdminsRequest.
 * Use `create(ListAdminsRequestSchema)` to create a new message.
 */
export const ListAdminsRequestSchema: GenMessage<ListAdminsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 3);

/**
 * ListAdminsResponse returns all admin users
 *
 * @generated from message cortado.v1.ListAdminsResponse
 */
export type ListAdminsResponse = Message<"cortado.v1.ListAdminsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Admin admins = 1;
   */
  admins: Admin[];
};

/**
 * Describes the message cortado.v1.ListAdminsResponse.
 * Use `create(ListAdminsResponseSchema)` to create a new message.
 */
export const ListAdminsResponseSchema: GenMessage<ListAdminsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 4);

/**
 * AdminCreateUserRequest creates a new app user by email
 *
 * @generated from message cortado.v1.AdminCreateUserRequest
 */
export type AdminCreateUserRequest = Message<"cortado.v1.AdminCreateUserRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: optional string first_name = 2;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 3;
   */
  lastName?: string;
};

/**
 * Describes the message cortado.v1.AdminCreateUserRequest.
 * Use `create(AdminCreateUserRequestSchema)` to create a new message.
 */
export const AdminCreateUserRequestSchema: GenMessage<AdminCreateUserRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 5);

/**
 * AdminCreateUserResponse returns the created user
 *
 * @generated from message cortado.v1.AdminCreateUserResponse
 */
export type AdminCreateUserResponse = Message<"cortado.v1.AdminCreateUserResponse"> & {
  /**
   * @generated from field: cortado.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message cortado.v1.AdminCreateUserResponse.
 * Use `create(AdminCreateUserResponseSchema)` to create a new message.
 */
export const AdminCreateUserResponseSchema: GenMessage<AdminCreateUserResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 6);

/**
 * AdminListUsersRequest lists all app users
 *
 * @generated from message cortado.v1.AdminListUsersRequest
 */
export type AdminListUsersRequest = Message<"cortado.v1.AdminListUsersRequest"> & {
  /**
   * @generated from field: optional int32 page_size = 1;
   */
  pageSize?: number;

  /**
   * @generated from field: optional string page_token = 2;
   */
  pageToken?: string;
};

/**
 * Describes the message cortado.v1.AdminListUsersRequest.
 * Use `create(AdminListUsersRequestSchema)` to create a new message.
 */
export const AdminListUsersRequestSchema: GenMessage<AdminListUsersRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 7);

/**
 * AdminUserOrgRef is a lightweight org reference for the admin user list view
 *
 * @generated from message cortado.v1.AdminUserOrgRef
 */
export type AdminUserOrgRef = Message<"cortado.v1.AdminUserOrgRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message cortado.v1.AdminUserOrgRef.
 * Use `create(AdminUserOrgRefSchema)` to create a new message.
 */
export const AdminUserOrgRefSchema: GenMessage<AdminUserOrgRef> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 8);

/**
 * AdminUserOrgList wraps a list of orgs (proto3 maps don't allow `repeated` values directly)
 *
 * @generated from message cortado.v1.AdminUserOrgList
 */
export type AdminUserOrgList = Message<"cortado.v1.AdminUserOrgList"> & {
  /**
   * @generated from field: repeated cortado.v1.AdminUserOrgRef organizations = 1;
   */
  organizations: AdminUserOrgRef[];
};

/**
 * Describes the message cortado.v1.AdminUserOrgList.
 * Use `create(AdminUserOrgListSchema)` to create a new message.
 */
export const AdminUserOrgListSchema: GenMessage<AdminUserOrgList> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 9);

/**
 * AdminListUsersResponse returns all app users
 *
 * @generated from message cortado.v1.AdminListUsersResponse
 */
export type AdminListUsersResponse = Message<"cortado.v1.AdminListUsersResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.User users = 1;
   */
  users: User[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;

  /**
   * Organizations associated with each user, keyed by user id
   *
   * @generated from field: map<string, cortado.v1.AdminUserOrgList> user_organizations = 4;
   */
  userOrganizations: { [key: string]: AdminUserOrgList };
};

/**
 * Describes the message cortado.v1.AdminListUsersResponse.
 * Use `create(AdminListUsersResponseSchema)` to create a new message.
 */
export const AdminListUsersResponseSchema: GenMessage<AdminListUsersResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 10);

/**
 * AdminResendInviteRequest resends an invitation email with a fresh magic link
 *
 * @generated from message cortado.v1.AdminResendInviteRequest
 */
export type AdminResendInviteRequest = Message<"cortado.v1.AdminResendInviteRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message cortado.v1.AdminResendInviteRequest.
 * Use `create(AdminResendInviteRequestSchema)` to create a new message.
 */
export const AdminResendInviteRequestSchema: GenMessage<AdminResendInviteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 11);

/**
 * AdminResendInviteResponse confirms the invite was resent
 *
 * @generated from message cortado.v1.AdminResendInviteResponse
 */
export type AdminResendInviteResponse = Message<"cortado.v1.AdminResendInviteResponse"> & {
};

/**
 * Describes the message cortado.v1.AdminResendInviteResponse.
 * Use `create(AdminResendInviteResponseSchema)` to create a new message.
 */
export const AdminResendInviteResponseSchema: GenMessage<AdminResendInviteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 12);

/**
 * AdminArchiveUserRequest archives a user account so it can no longer log in
 *
 * @generated from message cortado.v1.AdminArchiveUserRequest
 */
export type AdminArchiveUserRequest = Message<"cortado.v1.AdminArchiveUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message cortado.v1.AdminArchiveUserRequest.
 * Use `create(AdminArchiveUserRequestSchema)` to create a new message.
 */
export const AdminArchiveUserRequestSchema: GenMessage<AdminArchiveUserRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 13);

/**
 * AdminArchiveUserResponse returns the archived user
 *
 * @generated from message cortado.v1.AdminArchiveUserResponse
 */
export type AdminArchiveUserResponse = Message<"cortado.v1.AdminArchiveUserResponse"> & {
  /**
   * @generated from field: cortado.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message cortado.v1.AdminArchiveUserResponse.
 * Use `create(AdminArchiveUserResponseSchema)` to create a new message.
 */
export const AdminArchiveUserResponseSchema: GenMessage<AdminArchiveUserResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 14);

/**
 * AdminUnarchiveUserRequest unarchives a previously archived user account
 *
 * @generated from message cortado.v1.AdminUnarchiveUserRequest
 */
export type AdminUnarchiveUserRequest = Message<"cortado.v1.AdminUnarchiveUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message cortado.v1.AdminUnarchiveUserRequest.
 * Use `create(AdminUnarchiveUserRequestSchema)` to create a new message.
 */
export const AdminUnarchiveUserRequestSchema: GenMessage<AdminUnarchiveUserRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 15);

/**
 * AdminUnarchiveUserResponse returns the unarchived user
 *
 * @generated from message cortado.v1.AdminUnarchiveUserResponse
 */
export type AdminUnarchiveUserResponse = Message<"cortado.v1.AdminUnarchiveUserResponse"> & {
  /**
   * @generated from field: cortado.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message cortado.v1.AdminUnarchiveUserResponse.
 * Use `create(AdminUnarchiveUserResponseSchema)` to create a new message.
 */
export const AdminUnarchiveUserResponseSchema: GenMessage<AdminUnarchiveUserResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 16);

/**
 * @generated from message cortado.v1.AdminOrganization
 */
export type AdminOrganization = Message<"cortado.v1.AdminOrganization"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string slug = 3;
   */
  slug?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: repeated cortado.v1.OrganizationFeature features = 5;
   */
  features: OrganizationFeature[];
};

/**
 * Describes the message cortado.v1.AdminOrganization.
 * Use `create(AdminOrganizationSchema)` to create a new message.
 */
export const AdminOrganizationSchema: GenMessage<AdminOrganization> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 17);

/**
 * @generated from message cortado.v1.AdminListOrganizationsRequest
 */
export type AdminListOrganizationsRequest = Message<"cortado.v1.AdminListOrganizationsRequest"> & {
};

/**
 * Describes the message cortado.v1.AdminListOrganizationsRequest.
 * Use `create(AdminListOrganizationsRequestSchema)` to create a new message.
 */
export const AdminListOrganizationsRequestSchema: GenMessage<AdminListOrganizationsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 18);

/**
 * @generated from message cortado.v1.AdminListOrganizationsResponse
 */
export type AdminListOrganizationsResponse = Message<"cortado.v1.AdminListOrganizationsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.AdminOrganization organizations = 1;
   */
  organizations: AdminOrganization[];
};

/**
 * Describes the message cortado.v1.AdminListOrganizationsResponse.
 * Use `create(AdminListOrganizationsResponseSchema)` to create a new message.
 */
export const AdminListOrganizationsResponseSchema: GenMessage<AdminListOrganizationsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 19);

/**
 * @generated from message cortado.v1.AdminGetOrganizationFeaturesRequest
 */
export type AdminGetOrganizationFeaturesRequest = Message<"cortado.v1.AdminGetOrganizationFeaturesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationFeaturesRequest.
 * Use `create(AdminGetOrganizationFeaturesRequestSchema)` to create a new message.
 */
export const AdminGetOrganizationFeaturesRequestSchema: GenMessage<AdminGetOrganizationFeaturesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 20);

/**
 * @generated from message cortado.v1.AdminGetOrganizationFeaturesResponse
 */
export type AdminGetOrganizationFeaturesResponse = Message<"cortado.v1.AdminGetOrganizationFeaturesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.OrganizationFeature features = 1;
   */
  features: OrganizationFeature[];
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationFeaturesResponse.
 * Use `create(AdminGetOrganizationFeaturesResponseSchema)` to create a new message.
 */
export const AdminGetOrganizationFeaturesResponseSchema: GenMessage<AdminGetOrganizationFeaturesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 21);

/**
 * @generated from message cortado.v1.AdminEnableFeatureRequest
 */
export type AdminEnableFeatureRequest = Message<"cortado.v1.AdminEnableFeatureRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.OrganizationFeatureEnum feature = 2;
   */
  feature: OrganizationFeatureEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.AdminEnableFeatureRequest.
 * Use `create(AdminEnableFeatureRequestSchema)` to create a new message.
 */
export const AdminEnableFeatureRequestSchema: GenMessage<AdminEnableFeatureRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 22);

/**
 * @generated from message cortado.v1.AdminEnableFeatureResponse
 */
export type AdminEnableFeatureResponse = Message<"cortado.v1.AdminEnableFeatureResponse"> & {
};

/**
 * Describes the message cortado.v1.AdminEnableFeatureResponse.
 * Use `create(AdminEnableFeatureResponseSchema)` to create a new message.
 */
export const AdminEnableFeatureResponseSchema: GenMessage<AdminEnableFeatureResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 23);

/**
 * @generated from message cortado.v1.AdminDisableFeatureRequest
 */
export type AdminDisableFeatureRequest = Message<"cortado.v1.AdminDisableFeatureRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.OrganizationFeatureEnum feature = 2;
   */
  feature: OrganizationFeatureEnum;
};

/**
 * Describes the message cortado.v1.AdminDisableFeatureRequest.
 * Use `create(AdminDisableFeatureRequestSchema)` to create a new message.
 */
export const AdminDisableFeatureRequestSchema: GenMessage<AdminDisableFeatureRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 24);

/**
 * @generated from message cortado.v1.AdminDisableFeatureResponse
 */
export type AdminDisableFeatureResponse = Message<"cortado.v1.AdminDisableFeatureResponse"> & {
};

/**
 * Describes the message cortado.v1.AdminDisableFeatureResponse.
 * Use `create(AdminDisableFeatureResponseSchema)` to create a new message.
 */
export const AdminDisableFeatureResponseSchema: GenMessage<AdminDisableFeatureResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 25);

/**
 * AdminDisableFeatureForAllOrgs bulk-disables a feature's enabled rows across
 * every organization. Only permitted for flags whose lifecycle stage is GA or
 * Retired (internal/models/enums/organization_feature_lifecycle.go) — bulk
 * revocation of a live Experimental/Entitlement/TierMarker flag is rejected.
 *
 * @generated from message cortado.v1.AdminDisableFeatureForAllOrgsRequest
 */
export type AdminDisableFeatureForAllOrgsRequest = Message<"cortado.v1.AdminDisableFeatureForAllOrgsRequest"> & {
  /**
   * @generated from field: cortado.v1.OrganizationFeatureEnum feature = 1;
   */
  feature: OrganizationFeatureEnum;
};

/**
 * Describes the message cortado.v1.AdminDisableFeatureForAllOrgsRequest.
 * Use `create(AdminDisableFeatureForAllOrgsRequestSchema)` to create a new message.
 */
export const AdminDisableFeatureForAllOrgsRequestSchema: GenMessage<AdminDisableFeatureForAllOrgsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 26);

/**
 * @generated from message cortado.v1.AdminDisableFeatureForAllOrgsResponse
 */
export type AdminDisableFeatureForAllOrgsResponse = Message<"cortado.v1.AdminDisableFeatureForAllOrgsResponse"> & {
  /**
   * @generated from field: int32 disabled_count = 1;
   */
  disabledCount: number;
};

/**
 * Describes the message cortado.v1.AdminDisableFeatureForAllOrgsResponse.
 * Use `create(AdminDisableFeatureForAllOrgsResponseSchema)` to create a new message.
 */
export const AdminDisableFeatureForAllOrgsResponseSchema: GenMessage<AdminDisableFeatureForAllOrgsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 27);

/**
 * AdminFeatureCatalogEntry describes one OrganizationFeatureEnum value's
 * current lifecycle stage, sourced from the backend's lifecycle registry
 * (internal/models/enums/organization_feature_lifecycle.go).
 *
 * @generated from message cortado.v1.AdminFeatureCatalogEntry
 */
export type AdminFeatureCatalogEntry = Message<"cortado.v1.AdminFeatureCatalogEntry"> & {
  /**
   * @generated from field: cortado.v1.OrganizationFeatureEnum feature = 1;
   */
  feature: OrganizationFeatureEnum;

  /**
   * @generated from field: cortado.v1.OrganizationFeatureStageEnum stage = 2;
   */
  stage: OrganizationFeatureStageEnum;

  /**
   * enabled_org_count is the number of organizations that currently have an
   * ENABLED row for this feature.
   *
   * @generated from field: int32 enabled_org_count = 3;
   */
  enabledOrgCount: number;
};

/**
 * Describes the message cortado.v1.AdminFeatureCatalogEntry.
 * Use `create(AdminFeatureCatalogEntrySchema)` to create a new message.
 */
export const AdminFeatureCatalogEntrySchema: GenMessage<AdminFeatureCatalogEntry> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 28);

/**
 * AdminListFeatureCatalog returns the lifecycle stage of every declared
 * OrganizationFeatureEnum value, so the superadmin console can render the
 * set of flags that still gate something instead of hardcoding the enum list.
 *
 * @generated from message cortado.v1.AdminListFeatureCatalogRequest
 */
export type AdminListFeatureCatalogRequest = Message<"cortado.v1.AdminListFeatureCatalogRequest"> & {
};

/**
 * Describes the message cortado.v1.AdminListFeatureCatalogRequest.
 * Use `create(AdminListFeatureCatalogRequestSchema)` to create a new message.
 */
export const AdminListFeatureCatalogRequestSchema: GenMessage<AdminListFeatureCatalogRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 29);

/**
 * @generated from message cortado.v1.AdminListFeatureCatalogResponse
 */
export type AdminListFeatureCatalogResponse = Message<"cortado.v1.AdminListFeatureCatalogResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.AdminFeatureCatalogEntry entries = 1;
   */
  entries: AdminFeatureCatalogEntry[];
};

/**
 * Describes the message cortado.v1.AdminListFeatureCatalogResponse.
 * Use `create(AdminListFeatureCatalogResponseSchema)` to create a new message.
 */
export const AdminListFeatureCatalogResponseSchema: GenMessage<AdminListFeatureCatalogResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 30);

/**
 * AdminOrganizationUser is a lightweight user representation for admin views
 *
 * @generated from message cortado.v1.AdminOrganizationUser
 */
export type AdminOrganizationUser = Message<"cortado.v1.AdminOrganizationUser"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: optional string first_name = 3;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 4;
   */
  lastName?: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.AdminOrganizationUser.
 * Use `create(AdminOrganizationUserSchema)` to create a new message.
 */
export const AdminOrganizationUserSchema: GenMessage<AdminOrganizationUser> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 31);

/**
 * AdminOrganizationStats contains aggregate counts for an organization
 *
 * @generated from message cortado.v1.AdminOrganizationStats
 */
export type AdminOrganizationStats = Message<"cortado.v1.AdminOrganizationStats"> & {
  /**
   * @generated from field: int32 user_count = 1;
   */
  userCount: number;

  /**
   * @generated from field: int32 lead_count = 2;
   */
  leadCount: number;

  /**
   * @generated from field: int32 event_count = 3;
   */
  eventCount: number;

  /**
   * @generated from field: int32 invoice_count = 4;
   */
  invoiceCount: number;

  /**
   * @generated from field: int64 revenue_cents = 5;
   */
  revenueCents: bigint;
};

/**
 * Describes the message cortado.v1.AdminOrganizationStats.
 * Use `create(AdminOrganizationStatsSchema)` to create a new message.
 */
export const AdminOrganizationStatsSchema: GenMessage<AdminOrganizationStats> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 32);

/**
 * @generated from message cortado.v1.AdminGetOrganizationRequest
 */
export type AdminGetOrganizationRequest = Message<"cortado.v1.AdminGetOrganizationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationRequest.
 * Use `create(AdminGetOrganizationRequestSchema)` to create a new message.
 */
export const AdminGetOrganizationRequestSchema: GenMessage<AdminGetOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 33);

/**
 * @generated from message cortado.v1.AdminGetOrganizationResponse
 */
export type AdminGetOrganizationResponse = Message<"cortado.v1.AdminGetOrganizationResponse"> & {
  /**
   * @generated from field: cortado.v1.AdminOrganization organization = 1;
   */
  organization?: AdminOrganization;

  /**
   * @generated from field: repeated cortado.v1.AdminOrganizationUser users = 2;
   */
  users: AdminOrganizationUser[];

  /**
   * @generated from field: repeated cortado.v1.OrganizationFeature features = 3;
   */
  features: OrganizationFeature[];
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationResponse.
 * Use `create(AdminGetOrganizationResponseSchema)` to create a new message.
 */
export const AdminGetOrganizationResponseSchema: GenMessage<AdminGetOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 34);

/**
 * @generated from message cortado.v1.AdminGetOrganizationStatsRequest
 */
export type AdminGetOrganizationStatsRequest = Message<"cortado.v1.AdminGetOrganizationStatsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationStatsRequest.
 * Use `create(AdminGetOrganizationStatsRequestSchema)` to create a new message.
 */
export const AdminGetOrganizationStatsRequestSchema: GenMessage<AdminGetOrganizationStatsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 35);

/**
 * @generated from message cortado.v1.AdminGetOrganizationStatsResponse
 */
export type AdminGetOrganizationStatsResponse = Message<"cortado.v1.AdminGetOrganizationStatsResponse"> & {
  /**
   * @generated from field: cortado.v1.AdminOrganizationStats stats = 1;
   */
  stats?: AdminOrganizationStats;
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationStatsResponse.
 * Use `create(AdminGetOrganizationStatsResponseSchema)` to create a new message.
 */
export const AdminGetOrganizationStatsResponseSchema: GenMessage<AdminGetOrganizationStatsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 36);

/**
 * @generated from message cortado.v1.AdminGetSystemStatsRequest
 */
export type AdminGetSystemStatsRequest = Message<"cortado.v1.AdminGetSystemStatsRequest"> & {
};

/**
 * Describes the message cortado.v1.AdminGetSystemStatsRequest.
 * Use `create(AdminGetSystemStatsRequestSchema)` to create a new message.
 */
export const AdminGetSystemStatsRequestSchema: GenMessage<AdminGetSystemStatsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 37);

/**
 * @generated from message cortado.v1.AdminGetSystemStatsResponse
 */
export type AdminGetSystemStatsResponse = Message<"cortado.v1.AdminGetSystemStatsResponse"> & {
  /**
   * @generated from field: cortado.v1.AdminSystemStats stats = 1;
   */
  stats?: AdminSystemStats;
};

/**
 * Describes the message cortado.v1.AdminGetSystemStatsResponse.
 * Use `create(AdminGetSystemStatsResponseSchema)` to create a new message.
 */
export const AdminGetSystemStatsResponseSchema: GenMessage<AdminGetSystemStatsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 38);

/**
 * @generated from message cortado.v1.AdminSystemStats
 */
export type AdminSystemStats = Message<"cortado.v1.AdminSystemStats"> & {
  /**
   * @generated from field: cortado.v1.StatTrend organizations = 1;
   */
  organizations?: StatTrend;

  /**
   * @generated from field: cortado.v1.StatTrend users = 2;
   */
  users?: StatTrend;

  /**
   * @generated from field: cortado.v1.StatTrend leads = 3;
   */
  leads?: StatTrend;

  /**
   * @generated from field: cortado.v1.StatTrend events = 4;
   */
  events?: StatTrend;

  /**
   * @generated from field: cortado.v1.StatTrend invoices = 5;
   */
  invoices?: StatTrend;

  /**
   * @generated from field: cortado.v1.RevenueTrend revenue = 6;
   */
  revenue?: RevenueTrend;
};

/**
 * Describes the message cortado.v1.AdminSystemStats.
 * Use `create(AdminSystemStatsSchema)` to create a new message.
 */
export const AdminSystemStatsSchema: GenMessage<AdminSystemStats> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 39);

/**
 * @generated from message cortado.v1.StatTrend
 */
export type StatTrend = Message<"cortado.v1.StatTrend"> & {
  /**
   * @generated from field: int32 total = 1;
   */
  total: number;

  /**
   * @generated from field: int32 last_30_days = 2;
   */
  last30Days: number;

  /**
   * @generated from field: int32 previous_30_days = 3;
   */
  previous30Days: number;
};

/**
 * Describes the message cortado.v1.StatTrend.
 * Use `create(StatTrendSchema)` to create a new message.
 */
export const StatTrendSchema: GenMessage<StatTrend> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 40);

/**
 * @generated from message cortado.v1.RevenueTrend
 */
export type RevenueTrend = Message<"cortado.v1.RevenueTrend"> & {
  /**
   * @generated from field: int64 total_cents = 1;
   */
  totalCents: bigint;

  /**
   * @generated from field: int64 last_30_days_cents = 2;
   */
  last30DaysCents: bigint;

  /**
   * @generated from field: int64 previous_30_days_cents = 3;
   */
  previous30DaysCents: bigint;
};

/**
 * Describes the message cortado.v1.RevenueTrend.
 * Use `create(RevenueTrendSchema)` to create a new message.
 */
export const RevenueTrendSchema: GenMessage<RevenueTrend> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 41);

/**
 * AdminGetPlatformRevenueMetrics returns booked platform subscription MRR/ARR
 * plus last-30 vs previous-30 new subscriptions, upgrades, and downgrades.
 *
 * @generated from message cortado.v1.AdminGetPlatformRevenueMetricsRequest
 */
export type AdminGetPlatformRevenueMetricsRequest = Message<"cortado.v1.AdminGetPlatformRevenueMetricsRequest"> & {
};

/**
 * Describes the message cortado.v1.AdminGetPlatformRevenueMetricsRequest.
 * Use `create(AdminGetPlatformRevenueMetricsRequestSchema)` to create a new message.
 */
export const AdminGetPlatformRevenueMetricsRequestSchema: GenMessage<AdminGetPlatformRevenueMetricsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 42);

/**
 * @generated from message cortado.v1.AdminGetPlatformRevenueMetricsResponse
 */
export type AdminGetPlatformRevenueMetricsResponse = Message<"cortado.v1.AdminGetPlatformRevenueMetricsResponse"> & {
  /**
   * @generated from field: cortado.v1.PlatformRevenueMetrics metrics = 1;
   */
  metrics?: PlatformRevenueMetrics;
};

/**
 * Describes the message cortado.v1.AdminGetPlatformRevenueMetricsResponse.
 * Use `create(AdminGetPlatformRevenueMetricsResponseSchema)` to create a new message.
 */
export const AdminGetPlatformRevenueMetricsResponseSchema: GenMessage<AdminGetPlatformRevenueMetricsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 43);

/**
 * PlatformRevenueMetrics is Cortado's own booked subscription revenue, not
 * tenant invoice collections. Booked MRR includes trialing, grace, and
 * paused-payment orgs at full catalog/exception value; comp accounts are
 * excluded. Movement dollars use current catalog prices for the plan,
 * interval, and seats captured on each billing-state transition.
 *
 * @generated from message cortado.v1.PlatformRevenueMetrics
 */
export type PlatformRevenueMetrics = Message<"cortado.v1.PlatformRevenueMetrics"> & {
  /**
   * @generated from field: int64 booked_mrr_cents = 1;
   */
  bookedMrrCents: bigint;

  /**
   * @generated from field: int64 booked_arr_cents = 2;
   */
  bookedArrCents: bigint;

  /**
   * @generated from field: int32 recurring_organizations = 3;
   */
  recurringOrganizations: number;

  /**
   * @generated from field: cortado.v1.StatTrend new_subscriptions = 10;
   */
  newSubscriptions?: StatTrend;

  /**
   * @generated from field: cortado.v1.StatTrend upgrades = 11;
   */
  upgrades?: StatTrend;

  /**
   * @generated from field: cortado.v1.StatTrend downgrades = 12;
   */
  downgrades?: StatTrend;

  /**
   * @generated from field: cortado.v1.RevenueTrend net_mrr = 20;
   */
  netMrr?: RevenueTrend;

  /**
   * @generated from field: cortado.v1.RevenueTrend new_mrr = 21;
   */
  newMrr?: RevenueTrend;

  /**
   * @generated from field: cortado.v1.RevenueTrend expansion_mrr = 22;
   */
  expansionMrr?: RevenueTrend;

  /**
   * @generated from field: cortado.v1.RevenueTrend contraction_mrr = 23;
   */
  contractionMrr?: RevenueTrend;

  /**
   * @generated from field: cortado.v1.RevenueTrend churned_mrr = 24;
   */
  churnedMrr?: RevenueTrend;
};

/**
 * Describes the message cortado.v1.PlatformRevenueMetrics.
 * Use `create(PlatformRevenueMetricsSchema)` to create a new message.
 */
export const PlatformRevenueMetricsSchema: GenMessage<PlatformRevenueMetrics> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 44);

/**
 * @generated from message cortado.v1.AdminGetOrganizationLeaderboardRequest
 */
export type AdminGetOrganizationLeaderboardRequest = Message<"cortado.v1.AdminGetOrganizationLeaderboardRequest"> & {
  /**
   * Number of days to look back for windowed metrics. 0 or unset = all time.
   *
   * @generated from field: optional int32 window_days = 1;
   */
  windowDays?: number;
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationLeaderboardRequest.
 * Use `create(AdminGetOrganizationLeaderboardRequestSchema)` to create a new message.
 */
export const AdminGetOrganizationLeaderboardRequestSchema: GenMessage<AdminGetOrganizationLeaderboardRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 45);

/**
 * AdminOrganizationLeaderboardEntry is one org row in the superadmin leaderboard
 *
 * @generated from message cortado.v1.AdminOrganizationLeaderboardEntry
 */
export type AdminOrganizationLeaderboardEntry = Message<"cortado.v1.AdminOrganizationLeaderboardEntry"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * Stripe subscription status: active, trialing, past_due, canceled, unpaid. Empty if no subscription.
   *
   * @generated from field: string subscription_status = 5;
   */
  subscriptionStatus: string;

  /**
   * @generated from field: string default_currency = 6;
   */
  defaultCurrency: string;

  /**
   * @generated from field: int32 total_users = 7;
   */
  totalUsers: number;

  /**
   * Distinct users with activity in the window.
   *
   * @generated from field: int32 active_users = 8;
   */
  activeUsers: number;

  /**
   * @generated from field: int32 leads = 9;
   */
  leads: number;

  /**
   * Leads created in the window that converted to bookings.
   *
   * @generated from field: int32 converted_leads = 10;
   */
  convertedLeads: number;

  /**
   * @generated from field: int32 quotes_sent = 11;
   */
  quotesSent: number;

  /**
   * @generated from field: int32 quotes_accepted = 12;
   */
  quotesAccepted: number;

  /**
   * @generated from field: int32 invoices_sent = 13;
   */
  invoicesSent: number;

  /**
   * Payments actually collected in the window (Stripe + manual).
   *
   * @generated from field: int64 revenue_collected_cents = 14;
   */
  revenueCollectedCents: bigint;

  /**
   * Invoices created in the window that are now Paid (matches AdminGetSystemStats revenue definition).
   *
   * @generated from field: int64 invoiced_paid_cents = 15;
   */
  invoicedPaidCents: bigint;

  /**
   * @generated from field: int32 emails_sent = 16;
   */
  emailsSent: number;

  /**
   * All-time last activity for the org (not windowed). Absent if the org has no activity.
   *
   * @generated from field: optional google.protobuf.Timestamp last_activity_at = 17;
   */
  lastActivityAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.AdminOrganizationLeaderboardEntry.
 * Use `create(AdminOrganizationLeaderboardEntrySchema)` to create a new message.
 */
export const AdminOrganizationLeaderboardEntrySchema: GenMessage<AdminOrganizationLeaderboardEntry> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 46);

/**
 * @generated from message cortado.v1.AdminGetOrganizationLeaderboardResponse
 */
export type AdminGetOrganizationLeaderboardResponse = Message<"cortado.v1.AdminGetOrganizationLeaderboardResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.AdminOrganizationLeaderboardEntry entries = 1;
   */
  entries: AdminOrganizationLeaderboardEntry[];
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationLeaderboardResponse.
 * Use `create(AdminGetOrganizationLeaderboardResponseSchema)` to create a new message.
 */
export const AdminGetOrganizationLeaderboardResponseSchema: GenMessage<AdminGetOrganizationLeaderboardResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 47);

/**
 * AdminUpdateFeedbackStageRequest updates the stage of a feedback item
 *
 * @generated from message cortado.v1.AdminUpdateFeedbackStageRequest
 */
export type AdminUpdateFeedbackStageRequest = Message<"cortado.v1.AdminUpdateFeedbackStageRequest"> & {
  /**
   * Feedback ID to update
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * New stage for the feedback
   *
   * @generated from field: cortado.v1.FeedbackStageEnum stage = 2;
   */
  stage: FeedbackStageEnum;
};

/**
 * Describes the message cortado.v1.AdminUpdateFeedbackStageRequest.
 * Use `create(AdminUpdateFeedbackStageRequestSchema)` to create a new message.
 */
export const AdminUpdateFeedbackStageRequestSchema: GenMessage<AdminUpdateFeedbackStageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 48);

/**
 * AdminUpdateFeedbackStageResponse is empty on success
 *
 * @generated from message cortado.v1.AdminUpdateFeedbackStageResponse
 */
export type AdminUpdateFeedbackStageResponse = Message<"cortado.v1.AdminUpdateFeedbackStageResponse"> & {
};

/**
 * Describes the message cortado.v1.AdminUpdateFeedbackStageResponse.
 * Use `create(AdminUpdateFeedbackStageResponseSchema)` to create a new message.
 */
export const AdminUpdateFeedbackStageResponseSchema: GenMessage<AdminUpdateFeedbackStageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 49);

/**
 * @generated from message cortado.v1.EmailMarketingResource
 */
export type EmailMarketingResource = Message<"cortado.v1.EmailMarketingResource"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string dashboard_url = 3;
   */
  dashboardUrl: string;

  /**
   * @generated from field: bool configured = 4;
   */
  configured: boolean;

  /**
   * @generated from field: string description = 5;
   */
  description: string;
};

/**
 * Describes the message cortado.v1.EmailMarketingResource.
 * Use `create(EmailMarketingResourceSchema)` to create a new message.
 */
export const EmailMarketingResourceSchema: GenMessage<EmailMarketingResource> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 50);

/**
 * @generated from message cortado.v1.EmailMarketingDashboardLinks
 */
export type EmailMarketingDashboardLinks = Message<"cortado.v1.EmailMarketingDashboardLinks"> & {
  /**
   * @generated from field: string contacts_url = 1;
   */
  contactsUrl: string;

  /**
   * @generated from field: string segments_url = 2;
   */
  segmentsUrl: string;

  /**
   * @generated from field: string topics_url = 3;
   */
  topicsUrl: string;

  /**
   * @generated from field: string broadcasts_url = 4;
   */
  broadcastsUrl: string;
};

/**
 * Describes the message cortado.v1.EmailMarketingDashboardLinks.
 * Use `create(EmailMarketingDashboardLinksSchema)` to create a new message.
 */
export const EmailMarketingDashboardLinksSchema: GenMessage<EmailMarketingDashboardLinks> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 51);

/**
 * EmailMarketingAudienceSegment is one audience and the Resend segment that
 * holds it.
 *
 * @generated from message cortado.v1.EmailMarketingAudienceSegment
 */
export type EmailMarketingAudienceSegment = Message<"cortado.v1.EmailMarketingAudienceSegment"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingAudienceEnum audience = 1;
   */
  audience: EmailMarketingAudienceEnum;

  /**
   * @generated from field: cortado.v1.EmailMarketingResource segment = 2;
   */
  segment?: EmailMarketingResource;

  /**
   * People Cortado places in this audience right now. The Resend segment
   * matches this after the next contact sync.
   *
   * @generated from field: int32 member_count = 3;
   */
  memberCount: number;
};

/**
 * Describes the message cortado.v1.EmailMarketingAudienceSegment.
 * Use `create(EmailMarketingAudienceSegmentSchema)` to create a new message.
 */
export const EmailMarketingAudienceSegmentSchema: GenMessage<EmailMarketingAudienceSegment> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 52);

/**
 * @generated from message cortado.v1.EmailMarketingOverview
 */
export type EmailMarketingOverview = Message<"cortado.v1.EmailMarketingOverview"> & {
  /**
   * @generated from field: bool resend_configured = 1;
   */
  resendConfigured: boolean;

  /**
   * Deprecated: the old all-users "Cortado Users" segment. Nothing sends to it;
   * campaigns go to one of audience_segments.
   *
   * @generated from field: cortado.v1.EmailMarketingResource segment = 2 [deprecated = true];
   * @deprecated
   */
  segment?: EmailMarketingResource;

  /**
   * @generated from field: cortado.v1.EmailMarketingResource product_updates_topic = 3;
   */
  productUpdatesTopic?: EmailMarketingResource;

  /**
   * @generated from field: cortado.v1.EmailMarketingResource announcements_topic = 4;
   */
  announcementsTopic?: EmailMarketingResource;

  /**
   * @generated from field: int32 active_user_count = 5;
   */
  activeUserCount: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_synced_at = 6;
   */
  lastSyncedAt?: Timestamp;

  /**
   * @generated from field: int32 created_count = 7;
   */
  createdCount: number;

  /**
   * @generated from field: int32 updated_count = 8;
   */
  updatedCount: number;

  /**
   * @generated from field: int32 skipped_count = 9;
   */
  skippedCount: number;

  /**
   * @generated from field: int32 failed_count = 10;
   */
  failedCount: number;

  /**
   * @generated from field: cortado.v1.EmailMarketingDashboardLinks dashboard_links = 11;
   */
  dashboardLinks?: EmailMarketingDashboardLinks;

  /**
   * @generated from field: string sync_status = 12;
   */
  syncStatus: string;

  /**
   * @generated from field: string sync_workflow_id = 13;
   */
  syncWorkflowId: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp sync_started_at = 14;
   */
  syncStartedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp sync_completed_at = 15;
   */
  syncCompletedAt?: Timestamp;

  /**
   * @generated from field: int32 total_count = 16;
   */
  totalCount: number;

  /**
   * @generated from field: int32 processed_count = 17;
   */
  processedCount: number;

  /**
   * @generated from field: string last_error = 18;
   */
  lastError: string;

  /**
   * @generated from field: int32 warning_count = 19;
   */
  warningCount: number;

  /**
   * One per audience, in display order.
   *
   * @generated from field: repeated cortado.v1.EmailMarketingAudienceSegment audience_segments = 20;
   */
  audienceSegments: EmailMarketingAudienceSegment[];
};

/**
 * Describes the message cortado.v1.EmailMarketingOverview.
 * Use `create(EmailMarketingOverviewSchema)` to create a new message.
 */
export const EmailMarketingOverviewSchema: GenMessage<EmailMarketingOverview> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 53);

/**
 * @generated from message cortado.v1.GetEmailMarketingOverviewRequest
 */
export type GetEmailMarketingOverviewRequest = Message<"cortado.v1.GetEmailMarketingOverviewRequest"> & {
};

/**
 * Describes the message cortado.v1.GetEmailMarketingOverviewRequest.
 * Use `create(GetEmailMarketingOverviewRequestSchema)` to create a new message.
 */
export const GetEmailMarketingOverviewRequestSchema: GenMessage<GetEmailMarketingOverviewRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 54);

/**
 * @generated from message cortado.v1.GetEmailMarketingOverviewResponse
 */
export type GetEmailMarketingOverviewResponse = Message<"cortado.v1.GetEmailMarketingOverviewResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingOverview overview = 1;
   */
  overview?: EmailMarketingOverview;
};

/**
 * Describes the message cortado.v1.GetEmailMarketingOverviewResponse.
 * Use `create(GetEmailMarketingOverviewResponseSchema)` to create a new message.
 */
export const GetEmailMarketingOverviewResponseSchema: GenMessage<GetEmailMarketingOverviewResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 55);

/**
 * @generated from message cortado.v1.SyncEmailMarketingContactsRequest
 */
export type SyncEmailMarketingContactsRequest = Message<"cortado.v1.SyncEmailMarketingContactsRequest"> & {
};

/**
 * Describes the message cortado.v1.SyncEmailMarketingContactsRequest.
 * Use `create(SyncEmailMarketingContactsRequestSchema)` to create a new message.
 */
export const SyncEmailMarketingContactsRequestSchema: GenMessage<SyncEmailMarketingContactsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 56);

/**
 * @generated from message cortado.v1.SyncEmailMarketingContactsResponse
 */
export type SyncEmailMarketingContactsResponse = Message<"cortado.v1.SyncEmailMarketingContactsResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingOverview overview = 1;
   */
  overview?: EmailMarketingOverview;

  /**
   * @generated from field: string workflow_id = 2;
   */
  workflowId: string;
};

/**
 * Describes the message cortado.v1.SyncEmailMarketingContactsResponse.
 * Use `create(SyncEmailMarketingContactsResponseSchema)` to create a new message.
 */
export const SyncEmailMarketingContactsResponseSchema: GenMessage<SyncEmailMarketingContactsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 57);

/**
 * @generated from message cortado.v1.RepairEmailMarketingResourcesRequest
 */
export type RepairEmailMarketingResourcesRequest = Message<"cortado.v1.RepairEmailMarketingResourcesRequest"> & {
};

/**
 * Describes the message cortado.v1.RepairEmailMarketingResourcesRequest.
 * Use `create(RepairEmailMarketingResourcesRequestSchema)` to create a new message.
 */
export const RepairEmailMarketingResourcesRequestSchema: GenMessage<RepairEmailMarketingResourcesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 58);

/**
 * @generated from message cortado.v1.RepairEmailMarketingResourcesResponse
 */
export type RepairEmailMarketingResourcesResponse = Message<"cortado.v1.RepairEmailMarketingResourcesResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingOverview overview = 1;
   */
  overview?: EmailMarketingOverview;
};

/**
 * Describes the message cortado.v1.RepairEmailMarketingResourcesResponse.
 * Use `create(RepairEmailMarketingResourcesResponseSchema)` to create a new message.
 */
export const RepairEmailMarketingResourcesResponseSchema: GenMessage<RepairEmailMarketingResourcesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 59);

/**
 * @generated from message cortado.v1.ListEmailMarketingResourcesRequest
 */
export type ListEmailMarketingResourcesRequest = Message<"cortado.v1.ListEmailMarketingResourcesRequest"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingResourceTypeEnum type = 1;
   */
  type: EmailMarketingResourceTypeEnum;
};

/**
 * Describes the message cortado.v1.ListEmailMarketingResourcesRequest.
 * Use `create(ListEmailMarketingResourcesRequestSchema)` to create a new message.
 */
export const ListEmailMarketingResourcesRequestSchema: GenMessage<ListEmailMarketingResourcesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 60);

/**
 * @generated from message cortado.v1.ListEmailMarketingResourcesResponse
 */
export type ListEmailMarketingResourcesResponse = Message<"cortado.v1.ListEmailMarketingResourcesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.EmailMarketingResource resources = 1;
   */
  resources: EmailMarketingResource[];
};

/**
 * Describes the message cortado.v1.ListEmailMarketingResourcesResponse.
 * Use `create(ListEmailMarketingResourcesResponseSchema)` to create a new message.
 */
export const ListEmailMarketingResourcesResponseSchema: GenMessage<ListEmailMarketingResourcesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 61);

/**
 * @generated from message cortado.v1.CreateEmailMarketingResourceRequest
 */
export type CreateEmailMarketingResourceRequest = Message<"cortado.v1.CreateEmailMarketingResourceRequest"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingResourceTypeEnum type = 1;
   */
  type: EmailMarketingResourceTypeEnum;

  /**
   * @generated from field: string name = 20;
   */
  name: string;

  /**
   * @generated from field: string description = 21;
   */
  description: string;
};

/**
 * Describes the message cortado.v1.CreateEmailMarketingResourceRequest.
 * Use `create(CreateEmailMarketingResourceRequestSchema)` to create a new message.
 */
export const CreateEmailMarketingResourceRequestSchema: GenMessage<CreateEmailMarketingResourceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 62);

/**
 * @generated from message cortado.v1.CreateEmailMarketingResourceResponse
 */
export type CreateEmailMarketingResourceResponse = Message<"cortado.v1.CreateEmailMarketingResourceResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingResource resource = 1;
   */
  resource?: EmailMarketingResource;
};

/**
 * Describes the message cortado.v1.CreateEmailMarketingResourceResponse.
 * Use `create(CreateEmailMarketingResourceResponseSchema)` to create a new message.
 */
export const CreateEmailMarketingResourceResponseSchema: GenMessage<CreateEmailMarketingResourceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 63);

/**
 * @generated from message cortado.v1.EmailMarketingCampaign
 */
export type EmailMarketingCampaign = Message<"cortado.v1.EmailMarketingCampaign"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 20;
   */
  name: string;

  /**
   * @generated from field: cortado.v1.EmailMarketingChannelEnum channel = 21;
   */
  channel: EmailMarketingChannelEnum;

  /**
   * @generated from field: string subject = 22;
   */
  subject: string;

  /**
   * @generated from field: string html_body = 23;
   */
  htmlBody: string;

  /**
   * @generated from field: string text_body = 24;
   */
  textBody: string;

  /**
   * @generated from field: string content_hash = 25;
   */
  contentHash: string;

  /**
   * @generated from field: string resend_topic_id = 26;
   */
  resendTopicId: string;

  /**
   * @generated from field: string topic_name_snapshot = 27;
   */
  topicNameSnapshot: string;

  /**
   * Unspecified on campaigns sent before audiences existed and on drafts that
   * have not picked one; launch requires it.
   *
   * @generated from field: cortado.v1.EmailMarketingAudienceEnum audience = 28;
   */
  audience: EmailMarketingAudienceEnum;

  /**
   * @generated from field: cortado.v1.EmailMarketingCampaignStatusEnum status = 50;
   */
  status: EmailMarketingCampaignStatusEnum;

  /**
   * @generated from field: optional string resend_broadcast_id = 51;
   */
  resendBroadcastId?: string;

  /**
   * @generated from field: optional string workflow_id = 52;
   */
  workflowId?: string;

  /**
   * @generated from field: int32 recipient_count_snapshot = 53;
   */
  recipientCountSnapshot: number;

  /**
   * @generated from field: bool has_successful_current_test = 54;
   */
  hasSuccessfulCurrentTest: boolean;

  /**
   * @generated from field: optional string error_message = 55;
   */
  errorMessage?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_test_sent_at = 60;
   */
  lastTestSentAt?: Timestamp;

  /**
   * @generated from field: optional string last_test_sent_by = 61;
   */
  lastTestSentBy?: string;

  /**
   * @generated from field: repeated string last_test_recipients = 62;
   */
  lastTestRecipients: string[];

  /**
   * @generated from field: optional google.protobuf.Timestamp launched_at = 63;
   */
  launchedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp sent_at = 64;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_status_refreshed_at = 65;
   */
  lastStatusRefreshedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 66;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 67;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 68;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 69;
   */
  updatedBy: string;
};

/**
 * Describes the message cortado.v1.EmailMarketingCampaign.
 * Use `create(EmailMarketingCampaignSchema)` to create a new message.
 */
export const EmailMarketingCampaignSchema: GenMessage<EmailMarketingCampaign> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 64);

/**
 * @generated from message cortado.v1.ListEmailMarketingCampaignsRequest
 */
export type ListEmailMarketingCampaignsRequest = Message<"cortado.v1.ListEmailMarketingCampaignsRequest"> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 2;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListEmailMarketingCampaignsRequest.
 * Use `create(ListEmailMarketingCampaignsRequestSchema)` to create a new message.
 */
export const ListEmailMarketingCampaignsRequestSchema: GenMessage<ListEmailMarketingCampaignsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 65);

/**
 * @generated from message cortado.v1.ListEmailMarketingCampaignsResponse
 */
export type ListEmailMarketingCampaignsResponse = Message<"cortado.v1.ListEmailMarketingCampaignsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.EmailMarketingCampaign campaigns = 1;
   */
  campaigns: EmailMarketingCampaign[];
};

/**
 * Describes the message cortado.v1.ListEmailMarketingCampaignsResponse.
 * Use `create(ListEmailMarketingCampaignsResponseSchema)` to create a new message.
 */
export const ListEmailMarketingCampaignsResponseSchema: GenMessage<ListEmailMarketingCampaignsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 66);

/**
 * @generated from message cortado.v1.GetEmailMarketingCampaignRequest
 */
export type GetEmailMarketingCampaignRequest = Message<"cortado.v1.GetEmailMarketingCampaignRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetEmailMarketingCampaignRequest.
 * Use `create(GetEmailMarketingCampaignRequestSchema)` to create a new message.
 */
export const GetEmailMarketingCampaignRequestSchema: GenMessage<GetEmailMarketingCampaignRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 67);

/**
 * @generated from message cortado.v1.GetEmailMarketingCampaignResponse
 */
export type GetEmailMarketingCampaignResponse = Message<"cortado.v1.GetEmailMarketingCampaignResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingCampaign campaign = 1;
   */
  campaign?: EmailMarketingCampaign;
};

/**
 * Describes the message cortado.v1.GetEmailMarketingCampaignResponse.
 * Use `create(GetEmailMarketingCampaignResponseSchema)` to create a new message.
 */
export const GetEmailMarketingCampaignResponseSchema: GenMessage<GetEmailMarketingCampaignResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 68);

/**
 * @generated from message cortado.v1.CreateEmailMarketingCampaignRequest
 */
export type CreateEmailMarketingCampaignRequest = Message<"cortado.v1.CreateEmailMarketingCampaignRequest"> & {
  /**
   * @generated from field: string name = 20;
   */
  name: string;

  /**
   * @generated from field: cortado.v1.EmailMarketingChannelEnum channel = 21;
   */
  channel: EmailMarketingChannelEnum;

  /**
   * @generated from field: string subject = 22;
   */
  subject: string;

  /**
   * @generated from field: string html_body = 23;
   */
  htmlBody: string;

  /**
   * @generated from field: string text_body = 24;
   */
  textBody: string;

  /**
   * @generated from field: string resend_topic_id = 26;
   */
  resendTopicId: string;

  /**
   * @generated from field: cortado.v1.EmailMarketingAudienceEnum audience = 28;
   */
  audience: EmailMarketingAudienceEnum;
};

/**
 * Describes the message cortado.v1.CreateEmailMarketingCampaignRequest.
 * Use `create(CreateEmailMarketingCampaignRequestSchema)` to create a new message.
 */
export const CreateEmailMarketingCampaignRequestSchema: GenMessage<CreateEmailMarketingCampaignRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 69);

/**
 * @generated from message cortado.v1.CreateEmailMarketingCampaignResponse
 */
export type CreateEmailMarketingCampaignResponse = Message<"cortado.v1.CreateEmailMarketingCampaignResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingCampaign campaign = 1;
   */
  campaign?: EmailMarketingCampaign;
};

/**
 * Describes the message cortado.v1.CreateEmailMarketingCampaignResponse.
 * Use `create(CreateEmailMarketingCampaignResponseSchema)` to create a new message.
 */
export const CreateEmailMarketingCampaignResponseSchema: GenMessage<CreateEmailMarketingCampaignResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 70);

/**
 * @generated from message cortado.v1.UpdateEmailMarketingCampaignRequest
 */
export type UpdateEmailMarketingCampaignRequest = Message<"cortado.v1.UpdateEmailMarketingCampaignRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 20;
   */
  name: string;

  /**
   * @generated from field: cortado.v1.EmailMarketingChannelEnum channel = 21;
   */
  channel: EmailMarketingChannelEnum;

  /**
   * @generated from field: string subject = 22;
   */
  subject: string;

  /**
   * @generated from field: string html_body = 23;
   */
  htmlBody: string;

  /**
   * @generated from field: string text_body = 24;
   */
  textBody: string;

  /**
   * @generated from field: string resend_topic_id = 26;
   */
  resendTopicId: string;

  /**
   * @generated from field: cortado.v1.EmailMarketingAudienceEnum audience = 28;
   */
  audience: EmailMarketingAudienceEnum;
};

/**
 * Describes the message cortado.v1.UpdateEmailMarketingCampaignRequest.
 * Use `create(UpdateEmailMarketingCampaignRequestSchema)` to create a new message.
 */
export const UpdateEmailMarketingCampaignRequestSchema: GenMessage<UpdateEmailMarketingCampaignRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 71);

/**
 * @generated from message cortado.v1.UpdateEmailMarketingCampaignResponse
 */
export type UpdateEmailMarketingCampaignResponse = Message<"cortado.v1.UpdateEmailMarketingCampaignResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingCampaign campaign = 1;
   */
  campaign?: EmailMarketingCampaign;
};

/**
 * Describes the message cortado.v1.UpdateEmailMarketingCampaignResponse.
 * Use `create(UpdateEmailMarketingCampaignResponseSchema)` to create a new message.
 */
export const UpdateEmailMarketingCampaignResponseSchema: GenMessage<UpdateEmailMarketingCampaignResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 72);

/**
 * @generated from message cortado.v1.SendEmailMarketingCampaignTestRequest
 */
export type SendEmailMarketingCampaignTestRequest = Message<"cortado.v1.SendEmailMarketingCampaignTestRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated string recipients = 2;
   */
  recipients: string[];
};

/**
 * Describes the message cortado.v1.SendEmailMarketingCampaignTestRequest.
 * Use `create(SendEmailMarketingCampaignTestRequestSchema)` to create a new message.
 */
export const SendEmailMarketingCampaignTestRequestSchema: GenMessage<SendEmailMarketingCampaignTestRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 73);

/**
 * @generated from message cortado.v1.SendEmailMarketingCampaignTestResponse
 */
export type SendEmailMarketingCampaignTestResponse = Message<"cortado.v1.SendEmailMarketingCampaignTestResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingCampaign campaign = 1;
   */
  campaign?: EmailMarketingCampaign;
};

/**
 * Describes the message cortado.v1.SendEmailMarketingCampaignTestResponse.
 * Use `create(SendEmailMarketingCampaignTestResponseSchema)` to create a new message.
 */
export const SendEmailMarketingCampaignTestResponseSchema: GenMessage<SendEmailMarketingCampaignTestResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 74);

/**
 * @generated from message cortado.v1.LaunchEmailMarketingCampaignRequest
 */
export type LaunchEmailMarketingCampaignRequest = Message<"cortado.v1.LaunchEmailMarketingCampaignRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.LaunchEmailMarketingCampaignRequest.
 * Use `create(LaunchEmailMarketingCampaignRequestSchema)` to create a new message.
 */
export const LaunchEmailMarketingCampaignRequestSchema: GenMessage<LaunchEmailMarketingCampaignRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 75);

/**
 * @generated from message cortado.v1.LaunchEmailMarketingCampaignResponse
 */
export type LaunchEmailMarketingCampaignResponse = Message<"cortado.v1.LaunchEmailMarketingCampaignResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingCampaign campaign = 1;
   */
  campaign?: EmailMarketingCampaign;

  /**
   * @generated from field: string workflow_id = 2;
   */
  workflowId: string;
};

/**
 * Describes the message cortado.v1.LaunchEmailMarketingCampaignResponse.
 * Use `create(LaunchEmailMarketingCampaignResponseSchema)` to create a new message.
 */
export const LaunchEmailMarketingCampaignResponseSchema: GenMessage<LaunchEmailMarketingCampaignResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 76);

/**
 * @generated from message cortado.v1.RefreshEmailMarketingCampaignStatusRequest
 */
export type RefreshEmailMarketingCampaignStatusRequest = Message<"cortado.v1.RefreshEmailMarketingCampaignStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.RefreshEmailMarketingCampaignStatusRequest.
 * Use `create(RefreshEmailMarketingCampaignStatusRequestSchema)` to create a new message.
 */
export const RefreshEmailMarketingCampaignStatusRequestSchema: GenMessage<RefreshEmailMarketingCampaignStatusRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 77);

/**
 * @generated from message cortado.v1.RefreshEmailMarketingCampaignStatusResponse
 */
export type RefreshEmailMarketingCampaignStatusResponse = Message<"cortado.v1.RefreshEmailMarketingCampaignStatusResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailMarketingCampaign campaign = 1;
   */
  campaign?: EmailMarketingCampaign;
};

/**
 * Describes the message cortado.v1.RefreshEmailMarketingCampaignStatusResponse.
 * Use `create(RefreshEmailMarketingCampaignStatusResponseSchema)` to create a new message.
 */
export const RefreshEmailMarketingCampaignStatusResponseSchema: GenMessage<RefreshEmailMarketingCampaignStatusResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 78);

/**
 * @generated from message cortado.v1.SystemSettings
 */
export type SystemSettings = Message<"cortado.v1.SystemSettings"> & {
  /**
   * @generated from field: bool signup_enabled = 1;
   */
  signupEnabled: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by_user_id = 3;
   */
  updatedByUserId: string;

  /**
   * @generated from field: cortado.v1.AgentModelProviderEnum agent_model_provider = 20;
   */
  agentModelProvider: AgentModelProviderEnum;

  /**
   * @generated from field: string agent_model = 21;
   */
  agentModel: string;

  /**
   * Physical postal address included on Cortado marketing email.
   * CAN-SPAM requires a street address, post office box, or registered mailbox.
   *
   * @generated from field: string postal_address = 22;
   */
  postalAddress: string;
};

/**
 * Describes the message cortado.v1.SystemSettings.
 * Use `create(SystemSettingsSchema)` to create a new message.
 */
export const SystemSettingsSchema: GenMessage<SystemSettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 79);

/**
 * @generated from message cortado.v1.GetSystemSettingsAdminRequest
 */
export type GetSystemSettingsAdminRequest = Message<"cortado.v1.GetSystemSettingsAdminRequest"> & {
};

/**
 * Describes the message cortado.v1.GetSystemSettingsAdminRequest.
 * Use `create(GetSystemSettingsAdminRequestSchema)` to create a new message.
 */
export const GetSystemSettingsAdminRequestSchema: GenMessage<GetSystemSettingsAdminRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 80);

/**
 * @generated from message cortado.v1.GetSystemSettingsAdminResponse
 */
export type GetSystemSettingsAdminResponse = Message<"cortado.v1.GetSystemSettingsAdminResponse"> & {
  /**
   * @generated from field: cortado.v1.SystemSettings settings = 1;
   */
  settings?: SystemSettings;
};

/**
 * Describes the message cortado.v1.GetSystemSettingsAdminResponse.
 * Use `create(GetSystemSettingsAdminResponseSchema)` to create a new message.
 */
export const GetSystemSettingsAdminResponseSchema: GenMessage<GetSystemSettingsAdminResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 81);

/**
 * @generated from message cortado.v1.UpdateSystemSettingsRequest
 */
export type UpdateSystemSettingsRequest = Message<"cortado.v1.UpdateSystemSettingsRequest"> & {
  /**
   * @generated from field: cortado.v1.SystemSettings settings = 1;
   */
  settings?: SystemSettings;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateSystemSettingsRequest.
 * Use `create(UpdateSystemSettingsRequestSchema)` to create a new message.
 */
export const UpdateSystemSettingsRequestSchema: GenMessage<UpdateSystemSettingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 82);

/**
 * @generated from message cortado.v1.UpdateSystemSettingsResponse
 */
export type UpdateSystemSettingsResponse = Message<"cortado.v1.UpdateSystemSettingsResponse"> & {
  /**
   * @generated from field: cortado.v1.SystemSettings settings = 1;
   */
  settings?: SystemSettings;
};

/**
 * Describes the message cortado.v1.UpdateSystemSettingsResponse.
 * Use `create(UpdateSystemSettingsResponseSchema)` to create a new message.
 */
export const UpdateSystemSettingsResponseSchema: GenMessage<UpdateSystemSettingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 83);

/**
 * @generated from message cortado.v1.GetAiOrbConfigAdminRequest
 */
export type GetAiOrbConfigAdminRequest = Message<"cortado.v1.GetAiOrbConfigAdminRequest"> & {
};

/**
 * Describes the message cortado.v1.GetAiOrbConfigAdminRequest.
 * Use `create(GetAiOrbConfigAdminRequestSchema)` to create a new message.
 */
export const GetAiOrbConfigAdminRequestSchema: GenMessage<GetAiOrbConfigAdminRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 84);

/**
 * @generated from message cortado.v1.GetAiOrbConfigAdminResponse
 */
export type GetAiOrbConfigAdminResponse = Message<"cortado.v1.GetAiOrbConfigAdminResponse"> & {
  /**
   * Absent when no config has ever been saved; clients fall back to defaults.
   *
   * @generated from field: optional cortado.v1.AiOrbStateConfigs states = 2;
   */
  states?: AiOrbStateConfigs;
};

/**
 * Describes the message cortado.v1.GetAiOrbConfigAdminResponse.
 * Use `create(GetAiOrbConfigAdminResponseSchema)` to create a new message.
 */
export const GetAiOrbConfigAdminResponseSchema: GenMessage<GetAiOrbConfigAdminResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 85);

/**
 * @generated from message cortado.v1.UpdateAiOrbConfigRequest
 */
export type UpdateAiOrbConfigRequest = Message<"cortado.v1.UpdateAiOrbConfigRequest"> & {
  /**
   * @generated from field: cortado.v1.AiOrbStateConfigs states = 2;
   */
  states?: AiOrbStateConfigs;
};

/**
 * Describes the message cortado.v1.UpdateAiOrbConfigRequest.
 * Use `create(UpdateAiOrbConfigRequestSchema)` to create a new message.
 */
export const UpdateAiOrbConfigRequestSchema: GenMessage<UpdateAiOrbConfigRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 86);

/**
 * @generated from message cortado.v1.UpdateAiOrbConfigResponse
 */
export type UpdateAiOrbConfigResponse = Message<"cortado.v1.UpdateAiOrbConfigResponse"> & {
  /**
   * @generated from field: cortado.v1.AiOrbStateConfigs states = 2;
   */
  states?: AiOrbStateConfigs;
};

/**
 * Describes the message cortado.v1.UpdateAiOrbConfigResponse.
 * Use `create(UpdateAiOrbConfigResponseSchema)` to create a new message.
 */
export const UpdateAiOrbConfigResponseSchema: GenMessage<UpdateAiOrbConfigResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 87);

/**
 * @generated from message cortado.v1.RequeueFailedWorkflowTriggerEventsRequest
 */
export type RequeueFailedWorkflowTriggerEventsRequest = Message<"cortado.v1.RequeueFailedWorkflowTriggerEventsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional: specific trigger event ids to requeue. Empty requeues every
   * failed trigger event for the organization.
   *
   * @generated from field: repeated string trigger_event_ids = 2;
   */
  triggerEventIds: string[];
};

/**
 * Describes the message cortado.v1.RequeueFailedWorkflowTriggerEventsRequest.
 * Use `create(RequeueFailedWorkflowTriggerEventsRequestSchema)` to create a new message.
 */
export const RequeueFailedWorkflowTriggerEventsRequestSchema: GenMessage<RequeueFailedWorkflowTriggerEventsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 88);

/**
 * @generated from message cortado.v1.RequeueFailedWorkflowTriggerEventsResponse
 */
export type RequeueFailedWorkflowTriggerEventsResponse = Message<"cortado.v1.RequeueFailedWorkflowTriggerEventsResponse"> & {
  /**
   * @generated from field: int32 requeued_count = 1;
   */
  requeuedCount: number;
};

/**
 * Describes the message cortado.v1.RequeueFailedWorkflowTriggerEventsResponse.
 * Use `create(RequeueFailedWorkflowTriggerEventsResponseSchema)` to create a new message.
 */
export const RequeueFailedWorkflowTriggerEventsResponseSchema: GenMessage<RequeueFailedWorkflowTriggerEventsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 89);

/**
 * ResetWorkflowActionEffectRequest clears a `Started` workflow action effect
 * ledger row by id so a wedged node can be retried. Operator-only escape
 * hatch: it is a no-op if the row is missing or already Succeeded.
 * A `Started` row may belong to an action whose side effect actually completed
 * before the crash, so resetting it can replay that side effect (e.g. a second
 * customer email). Confirm the effect did not land before calling this.
 *
 * @generated from message cortado.v1.ResetWorkflowActionEffectRequest
 */
export type ResetWorkflowActionEffectRequest = Message<"cortado.v1.ResetWorkflowActionEffectRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.ResetWorkflowActionEffectRequest.
 * Use `create(ResetWorkflowActionEffectRequestSchema)` to create a new message.
 */
export const ResetWorkflowActionEffectRequestSchema: GenMessage<ResetWorkflowActionEffectRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 90);

/**
 * @generated from message cortado.v1.ResetWorkflowActionEffectResponse
 */
export type ResetWorkflowActionEffectResponse = Message<"cortado.v1.ResetWorkflowActionEffectResponse"> & {
  /**
   * True if a Started row matched and was reset.
   *
   * @generated from field: bool did_reset = 1;
   */
  didReset: boolean;
};

/**
 * Describes the message cortado.v1.ResetWorkflowActionEffectResponse.
 * Use `create(ResetWorkflowActionEffectResponseSchema)` to create a new message.
 */
export const ResetWorkflowActionEffectResponseSchema: GenMessage<ResetWorkflowActionEffectResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 91);

/**
 * FailedWorkflowTriggerEvent is a lightweight, list-view projection of a
 * retry-exhausted workflow_trigger_events row. payload_summary is a truncated
 * rendering of the raw JSON payload (not the full blob) so operators can see
 * the identifying fields at a glance without a follow-up call.
 *
 * @generated from message cortado.v1.FailedWorkflowTriggerEvent
 */
export type FailedWorkflowTriggerEvent = Message<"cortado.v1.FailedWorkflowTriggerEvent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string event_type = 3;
   */
  eventType: string;

  /**
   * @generated from field: string dedupe_key = 4;
   */
  dedupeKey: string;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 5;
   */
  occurredAt?: Timestamp;

  /**
   * @generated from field: int32 retry_count = 6;
   */
  retryCount: number;

  /**
   * @generated from field: optional string error_message = 7;
   */
  errorMessage?: string;

  /**
   * @generated from field: string payload_summary = 8;
   */
  payloadSummary: string;
};

/**
 * Describes the message cortado.v1.FailedWorkflowTriggerEvent.
 * Use `create(FailedWorkflowTriggerEventSchema)` to create a new message.
 */
export const FailedWorkflowTriggerEventSchema: GenMessage<FailedWorkflowTriggerEvent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 92);

/**
 * ListFailedWorkflowTriggerEventsRequest lists retry-exhausted trigger events
 * across the platform, optionally scoped to a single organization.
 *
 * @generated from message cortado.v1.ListFailedWorkflowTriggerEventsRequest
 */
export type ListFailedWorkflowTriggerEventsRequest = Message<"cortado.v1.ListFailedWorkflowTriggerEventsRequest"> & {
  /**
   * @generated from field: optional string organization_id = 1;
   */
  organizationId?: string;

  /**
   * @generated from field: optional int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: optional string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message cortado.v1.ListFailedWorkflowTriggerEventsRequest.
 * Use `create(ListFailedWorkflowTriggerEventsRequestSchema)` to create a new message.
 */
export const ListFailedWorkflowTriggerEventsRequestSchema: GenMessage<ListFailedWorkflowTriggerEventsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 93);

/**
 * @generated from message cortado.v1.ListFailedWorkflowTriggerEventsResponse
 */
export type ListFailedWorkflowTriggerEventsResponse = Message<"cortado.v1.ListFailedWorkflowTriggerEventsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.FailedWorkflowTriggerEvent trigger_events = 1;
   */
  triggerEvents: FailedWorkflowTriggerEvent[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListFailedWorkflowTriggerEventsResponse.
 * Use `create(ListFailedWorkflowTriggerEventsResponseSchema)` to create a new message.
 */
export const ListFailedWorkflowTriggerEventsResponseSchema: GenMessage<ListFailedWorkflowTriggerEventsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 94);

/**
 * RequeueWorkflowTriggerEventRequest requeues a single failed trigger event by
 * id — the targeted counterpart to RequeueFailedWorkflowTriggerEvents' bulk
 * per-organization requeue.
 *
 * @generated from message cortado.v1.RequeueWorkflowTriggerEventRequest
 */
export type RequeueWorkflowTriggerEventRequest = Message<"cortado.v1.RequeueWorkflowTriggerEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.RequeueWorkflowTriggerEventRequest.
 * Use `create(RequeueWorkflowTriggerEventRequestSchema)` to create a new message.
 */
export const RequeueWorkflowTriggerEventRequestSchema: GenMessage<RequeueWorkflowTriggerEventRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 95);

/**
 * @generated from message cortado.v1.RequeueWorkflowTriggerEventResponse
 */
export type RequeueWorkflowTriggerEventResponse = Message<"cortado.v1.RequeueWorkflowTriggerEventResponse"> & {
  /**
   * True if a failed row matched the id and was requeued. False for a
   * non-existent id or a row that is not currently failed.
   *
   * @generated from field: bool did_requeue = 1;
   */
  didRequeue: boolean;
};

/**
 * Describes the message cortado.v1.RequeueWorkflowTriggerEventResponse.
 * Use `create(RequeueWorkflowTriggerEventResponseSchema)` to create a new message.
 */
export const RequeueWorkflowTriggerEventResponseSchema: GenMessage<RequeueWorkflowTriggerEventResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 96);

/**
 * OrgBillingSummary is a lite, list-view projection of an organization's
 * billing state for the admin billing overview grid.
 *
 * @generated from message cortado.v1.OrgBillingSummary
 */
export type OrgBillingSummary = Message<"cortado.v1.OrgBillingSummary"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string organization_name = 2;
   */
  organizationName: string;

  /**
   * @generated from field: cortado.v1.BillingAccessStateEnum state = 10;
   */
  state: BillingAccessStateEnum;

  /**
   * @generated from field: cortado.v1.PlanKeyEnum assigned_plan_key = 11;
   */
  assignedPlanKey: PlanKeyEnum;

  /**
   * @generated from field: cortado.v1.BillingIntervalEnum selected_interval = 12;
   */
  selectedInterval: BillingIntervalEnum;

  /**
   * @generated from field: bool has_payment_method = 20;
   */
  hasPaymentMethod: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_charge_at = 21;
   */
  firstChargeAt?: Timestamp;

  /**
   * @generated from field: int32 billable_seats = 23;
   */
  billableSeats: number;

  /**
   * Booked monthly value, computed server-side from the subscription's
   * actual catalog generation, cadence, seats, and applied rate exception.
   *
   * @generated from field: int64 monthly_recurring_revenue_cents = 40;
   */
  monthlyRecurringRevenueCents: bigint;
};

/**
 * Describes the message cortado.v1.OrgBillingSummary.
 * Use `create(OrgBillingSummarySchema)` to create a new message.
 */
export const OrgBillingSummarySchema: GenMessage<OrgBillingSummary> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 97);

/**
 * BillingReminderSend is one row of an organization's pre-charge / renewal
 * reminder log (subscriptions.billing_reminder_sends), surfaced on the
 * single-org billing drill-in.
 *
 * @generated from message cortado.v1.BillingReminderSend
 */
export type BillingReminderSend = Message<"cortado.v1.BillingReminderSend"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * e.g. pre_charge_t7, pre_charge_t2, renewal_t14
   *
   * @generated from field: string reminder_key = 2;
   */
  reminderKey: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_for = 10;
   */
  scheduledFor?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp sent_at = 11;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: optional string skip_reason = 12;
   */
  skipReason?: string;

  /**
   * @generated from field: optional string superseded_reason = 13;
   */
  supersededReason?: string;
};

/**
 * Describes the message cortado.v1.BillingReminderSend.
 * Use `create(BillingReminderSendSchema)` to create a new message.
 */
export const BillingReminderSendSchema: GenMessage<BillingReminderSend> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 98);

/**
 * BillingStateTransition is one distinct billing_state change reconstructed
 * from the org_billing_state audit twin (subscriptions.org_billing_state_audit),
 * surfaced as the single-org billing drill-in's state timeline. from_state is
 * unset (BILLING_ACCESS_STATE_UNSPECIFIED) for the org's initial state at
 * creation.
 *
 * @generated from message cortado.v1.BillingStateTransition
 */
export type BillingStateTransition = Message<"cortado.v1.BillingStateTransition"> & {
  /**
   * @generated from field: cortado.v1.BillingAccessStateEnum from_state = 1;
   */
  fromState: BillingAccessStateEnum;

  /**
   * @generated from field: cortado.v1.BillingAccessStateEnum to_state = 2;
   */
  toState: BillingAccessStateEnum;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 10;
   */
  occurredAt?: Timestamp;

  /**
   * source identifies the writer: a user id, or "system" for
   * webhook/timer-driven transitions.
   *
   * @generated from field: string source = 20;
   */
  source: string;
};

/**
 * Describes the message cortado.v1.BillingStateTransition.
 * Use `create(BillingStateTransitionSchema)` to create a new message.
 */
export const BillingStateTransitionSchema: GenMessage<BillingStateTransition> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 99);

/**
 * SeatHistoryEntry is one distinct desired/applied seat-count change
 * reconstructed from the org_billing_state audit twin, surfaced on the
 * single-org billing drill-in.
 *
 * @generated from message cortado.v1.SeatHistoryEntry
 */
export type SeatHistoryEntry = Message<"cortado.v1.SeatHistoryEntry"> & {
  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 10;
   */
  occurredAt?: Timestamp;

  /**
   * @generated from field: int32 desired_seats = 20;
   */
  desiredSeats: number;

  /**
   * @generated from field: int32 applied_seats = 21;
   */
  appliedSeats: number;

  /**
   * source identifies the writer: a user id, or "system" for
   * webhook/timer-driven changes.
   *
   * @generated from field: string source = 30;
   */
  source: string;
};

/**
 * Describes the message cortado.v1.SeatHistoryEntry.
 * Use `create(SeatHistoryEntrySchema)` to create a new message.
 */
export const SeatHistoryEntrySchema: GenMessage<SeatHistoryEntry> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 100);

/**
 * RateException is a rate-protection or trial-extension exception ledger row
 * (subscriptions.rate_exceptions) - R-80/§29.
 *
 * @generated from message cortado.v1.RateException
 */
export type RateException = Message<"cortado.v1.RateException"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string account_name = 20;
   */
  accountName: string;

  /**
   * @generated from field: string approved_rate_description = 21;
   */
  approvedRateDescription: string;

  /**
   * @generated from field: string reason = 22;
   */
  reason: string;

  /**
   * @generated from field: google.protobuf.Timestamp effective_date = 23;
   */
  effectiveDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration_date = 24;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: string approver_name = 25;
   */
  approverName: string;

  /**
   * @generated from field: string approval_reference = 26;
   */
  approvalReference: string;

  /**
   * "rate" | "trial" | "volume_trial"
   *
   * @generated from field: string exception_kind = 27;
   */
  exceptionKind: string;

  /**
   * Required when exception_kind is "trial" (the length) or "volume_trial"
   * (the backstop).
   *
   * @generated from field: optional int32 approved_trial_days = 28;
   */
  approvedTrialDays?: number;

  /**
   * amount_cents is a PER-MONTH discount, required when exception_kind =
   * "rate". Cortado derives the concrete Stripe coupon for each product by
   * multiplying this by that product's interval_months - e.g. $50 here
   * becomes a $600.00 discount on an annual product (interval_months = 12),
   * not $50.00.
   *
   * @generated from field: optional int64 amount_cents = 29;
   */
  amountCents?: bigint;

  /**
   * @generated from field: optional string stripe_coupon_id = 30;
   */
  stripeCouponId?: string;

  /**
   * seat_coverage_cents is also PER-MONTH and multiplied by interval_months
   * the same way amount_cents is - an explicit seat-inclusive exception
   * allowance (R-106: a rate exception does not discount seat pricing
   * unless this is set).
   *
   * @generated from field: optional int64 seat_coverage_cents = 31;
   */
  seatCoverageCents?: bigint;

  /**
   * Required when exception_kind = "volume_trial": the Stripe Connect volume,
   * in cents, that ends the trial before approved_trial_days.
   *
   * @generated from field: optional int64 approved_volume_threshold_cents = 32;
   */
  approvedVolumeThresholdCents?: bigint;

  /**
   * "PENDING" | "APPLIED" | "EXPIRED" | "REVOKED" | "FAILED"
   *
   * @generated from field: string status = 50;
   */
  status: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp applied_at = 51;
   */
  appliedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp revoked_at = 52;
   */
  revokedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.RateException.
 * Use `create(RateExceptionSchema)` to create a new message.
 */
export const RateExceptionSchema: GenMessage<RateException> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 101);

/**
 * AccessOverride is a comp, whitelist, or suspend override
 * (subscriptions.access_overrides) - R-73, R-83.
 *
 * @generated from message cortado.v1.AccessOverride
 */
export type AccessOverride = Message<"cortado.v1.AccessOverride"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * "comp" | "whitelist" | "suspend"
   *
   * @generated from field: string override_kind = 20;
   */
  overrideKind: string;

  /**
   * @generated from field: string reason = 21;
   */
  reason: string;

  /**
   * @generated from field: google.protobuf.Timestamp starts_at = 22;
   */
  startsAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp ends_at = 23;
   */
  endsAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp revoked_at = 24;
   */
  revokedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 61;
   */
  createdBy: string;
};

/**
 * Describes the message cortado.v1.AccessOverride.
 * Use `create(AccessOverrideSchema)` to create a new message.
 */
export const AccessOverrideSchema: GenMessage<AccessOverride> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 102);

/**
 * PlanEligibility is one Founder or CCC eligibility list row
 * (subscriptions.plan_eligibility) - R-74, R-82.
 *
 * @generated from message cortado.v1.PlanEligibility
 */
export type PlanEligibility = Message<"cortado.v1.PlanEligibility"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string organization_id = 2;
   */
  organizationId?: string;

  /**
   * "founder" | "ccc"
   *
   * @generated from field: string list_kind = 3;
   */
  listKind: string;

  /**
   * @generated from field: string account_name = 4;
   */
  accountName: string;

  /**
   * @generated from field: optional string external_member_key = 5;
   */
  externalMemberKey?: string;

  /**
   * "active" | "inactive" | "unverified"
   *
   * @generated from field: string status = 10;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp status_read_at = 11;
   */
  statusReadAt?: Timestamp;

  /**
   * "frozen_list" | "admin" | "ccc_sync" | "system"
   *
   * @generated from field: string status_source = 12;
   */
  statusSource: string;

  /**
   * @generated from field: optional string notes = 13;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.PlanEligibility.
 * Use `create(PlanEligibilitySchema)` to create a new message.
 */
export const PlanEligibilitySchema: GenMessage<PlanEligibility> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 103);

/**
 * RetentionDueRow is one row of the R-56 manual data-deletion queue.
 *
 * @generated from message cortado.v1.RetentionDueRow
 */
export type RetentionDueRow = Message<"cortado.v1.RetentionDueRow"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string organization_name = 2;
   */
  organizationName: string;

  /**
   * @generated from field: google.protobuf.Timestamp data_retention_until = 3;
   */
  dataRetentionUntil?: Timestamp;
};

/**
 * Describes the message cortado.v1.RetentionDueRow.
 * Use `create(RetentionDueRowSchema)` to create a new message.
 */
export const RetentionDueRowSchema: GenMessage<RetentionDueRow> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 104);

/**
 * BillingLaunchConfig is the singleton subscription enforcement boundary.
 *
 * @generated from message cortado.v1.BillingLaunchConfig
 */
export type BillingLaunchConfig = Message<"cortado.v1.BillingLaunchConfig"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp billing_launch_at = 2;
   */
  billingLaunchAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.BillingLaunchConfig.
 * Use `create(BillingLaunchConfigSchema)` to create a new message.
 */
export const BillingLaunchConfigSchema: GenMessage<BillingLaunchConfig> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 105);

/**
 * OrgBillingDetail is the full single-org billing drill-in: state, plan,
 * trial/charge dates, seats, Stripe ids, and every exception/override/reminder
 * record on file for the org.
 *
 * @generated from message cortado.v1.OrgBillingDetail
 */
export type OrgBillingDetail = Message<"cortado.v1.OrgBillingDetail"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string organization_name = 2;
   */
  organizationName: string;

  /**
   * @generated from field: cortado.v1.OrganizationBillingState billing_state = 10;
   */
  billingState?: OrganizationBillingState;

  /**
   * @generated from field: optional string stripe_customer_id = 20;
   */
  stripeCustomerId?: string;

  /**
   * @generated from field: optional string stripe_subscription_id = 21;
   */
  stripeSubscriptionId?: string;

  /**
   * @generated from field: int32 included_seats = 30;
   */
  includedSeats: number;

  /**
   * @generated from field: int32 billable_seats = 31;
   */
  billableSeats: number;

  /**
   * @generated from field: repeated cortado.v1.RateException rate_exceptions = 40;
   */
  rateExceptions: RateException[];

  /**
   * @generated from field: repeated cortado.v1.AccessOverride access_overrides = 41;
   */
  accessOverrides: AccessOverride[];

  /**
   * @generated from field: repeated cortado.v1.BillingReminderSend reminder_log = 42;
   */
  reminderLog: BillingReminderSend[];

  /**
   * @generated from field: repeated cortado.v1.BillingStateTransition state_timeline = 43;
   */
  stateTimeline: BillingStateTransition[];

  /**
   * @generated from field: repeated cortado.v1.SeatHistoryEntry seat_history = 44;
   */
  seatHistory: SeatHistoryEntry[];

  /**
   * chargeback_flagged is DEC-45: a Stripe refund/dispute webhook was
   * received for this organization's platform subscription. Suspension
   * remains a manual A7 (AdminSetAccessOverride "suspend") action.
   *
   * @generated from field: bool chargeback_flagged = 50;
   */
  chargebackFlagged: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_chargeback_at = 51;
   */
  lastChargebackAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.OrgBillingDetail.
 * Use `create(OrgBillingDetailSchema)` to create a new message.
 */
export const OrgBillingDetailSchema: GenMessage<OrgBillingDetail> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 106);

/**
 * AdminListOrganizationBilling lists organizations for the admin billing
 * overview grid, filterable by state, plan, and payment method.
 *
 * @generated from message cortado.v1.AdminListOrganizationBillingRequest
 */
export type AdminListOrganizationBillingRequest = Message<"cortado.v1.AdminListOrganizationBillingRequest"> & {
  /**
   * @generated from field: optional cortado.v1.BillingAccessStateEnum state = 1;
   */
  state?: BillingAccessStateEnum;

  /**
   * @generated from field: optional cortado.v1.PlanKeyEnum plan_key = 2;
   */
  planKey?: PlanKeyEnum;

  /**
   * @generated from field: optional bool has_payment_method = 3;
   */
  hasPaymentMethod?: boolean;

  /**
   * @generated from field: optional int32 page_size = 10;
   */
  pageSize?: number;

  /**
   * @generated from field: optional string page_token = 11;
   */
  pageToken?: string;
};

/**
 * Describes the message cortado.v1.AdminListOrganizationBillingRequest.
 * Use `create(AdminListOrganizationBillingRequestSchema)` to create a new message.
 */
export const AdminListOrganizationBillingRequestSchema: GenMessage<AdminListOrganizationBillingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 107);

/**
 * @generated from message cortado.v1.AdminListOrganizationBillingResponse
 */
export type AdminListOrganizationBillingResponse = Message<"cortado.v1.AdminListOrganizationBillingResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.OrgBillingSummary organizations = 1;
   */
  organizations: OrgBillingSummary[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.AdminListOrganizationBillingResponse.
 * Use `create(AdminListOrganizationBillingResponseSchema)` to create a new message.
 */
export const AdminListOrganizationBillingResponseSchema: GenMessage<AdminListOrganizationBillingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 108);

/**
 * AdminGetOrganizationBilling retrieves the full billing drill-in for a
 * single organization.
 *
 * @generated from message cortado.v1.AdminGetOrganizationBillingRequest
 */
export type AdminGetOrganizationBillingRequest = Message<"cortado.v1.AdminGetOrganizationBillingRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationBillingRequest.
 * Use `create(AdminGetOrganizationBillingRequestSchema)` to create a new message.
 */
export const AdminGetOrganizationBillingRequestSchema: GenMessage<AdminGetOrganizationBillingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 109);

/**
 * @generated from message cortado.v1.AdminGetOrganizationBillingResponse
 */
export type AdminGetOrganizationBillingResponse = Message<"cortado.v1.AdminGetOrganizationBillingResponse"> & {
  /**
   * @generated from field: cortado.v1.OrgBillingDetail billing = 1;
   */
  billing?: OrgBillingDetail;
};

/**
 * Describes the message cortado.v1.AdminGetOrganizationBillingResponse.
 * Use `create(AdminGetOrganizationBillingResponseSchema)` to create a new message.
 */
export const AdminGetOrganizationBillingResponseSchema: GenMessage<AdminGetOrganizationBillingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 110);

/**
 * AdminSetBillingStartDate is Cortado-admin discretion (R-104), not a Jonny
 * approval: any admin may move an organization's trialing-only first charge
 * date. Refuses with FailedPrecondition when the subscription is not
 * trialing, or when first_charge_at is already past or under 60 minutes away
 * without confirm_near_deadline (§3.3).
 *
 * @generated from message cortado.v1.AdminSetBillingStartDateRequest
 */
export type AdminSetBillingStartDateRequest = Message<"cortado.v1.AdminSetBillingStartDateRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: google.protobuf.Timestamp billing_start_date = 2;
   */
  billingStartDate?: Timestamp;

  /**
   * @generated from field: int32 approved_extension_days = 3;
   */
  approvedExtensionDays: number;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * @generated from field: string approver_name = 5;
   */
  approverName: string;

  /**
   * approval_reference defaults to the sentinel "admin-discretion" server-side
   * when omitted (R-104/DEC-33).
   *
   * @generated from field: optional string approval_reference = 6;
   */
  approvalReference?: string;

  /**
   * @generated from field: google.protobuf.Timestamp effective_date = 7;
   */
  effectiveDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration_date = 8;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: bool confirm_near_deadline = 9;
   */
  confirmNearDeadline: boolean;
};

/**
 * Describes the message cortado.v1.AdminSetBillingStartDateRequest.
 * Use `create(AdminSetBillingStartDateRequestSchema)` to create a new message.
 */
export const AdminSetBillingStartDateRequestSchema: GenMessage<AdminSetBillingStartDateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 111);

/**
 * @generated from message cortado.v1.AdminSetBillingStartDateResponse
 */
export type AdminSetBillingStartDateResponse = Message<"cortado.v1.AdminSetBillingStartDateResponse"> & {
  /**
   * @generated from field: cortado.v1.OrgBillingDetail billing = 1;
   */
  billing?: OrgBillingDetail;
};

/**
 * Describes the message cortado.v1.AdminSetBillingStartDateResponse.
 * Use `create(AdminSetBillingStartDateResponseSchema)` to create a new message.
 */
export const AdminSetBillingStartDateResponseSchema: GenMessage<AdminSetBillingStartDateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 112);

/**
 * AdminSetVolumeTrialThreshold changes a volume trial's threshold. It is
 * refused once the threshold was reached. A threshold at or below the volume
 * already processed ends a running trial now.
 *
 * @generated from message cortado.v1.AdminSetVolumeTrialThresholdRequest
 */
export type AdminSetVolumeTrialThresholdRequest = Message<"cortado.v1.AdminSetVolumeTrialThresholdRequest"> & {
  /**
   * @generated from field: string rate_exception_id = 1;
   */
  rateExceptionId: string;

  /**
   * @generated from field: int64 threshold_cents = 2;
   */
  thresholdCents: bigint;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message cortado.v1.AdminSetVolumeTrialThresholdRequest.
 * Use `create(AdminSetVolumeTrialThresholdRequestSchema)` to create a new message.
 */
export const AdminSetVolumeTrialThresholdRequestSchema: GenMessage<AdminSetVolumeTrialThresholdRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 113);

/**
 * @generated from message cortado.v1.AdminSetVolumeTrialThresholdResponse
 */
export type AdminSetVolumeTrialThresholdResponse = Message<"cortado.v1.AdminSetVolumeTrialThresholdResponse"> & {
  /**
   * @generated from field: cortado.v1.OrgBillingDetail billing = 1;
   */
  billing?: OrgBillingDetail;
};

/**
 * Describes the message cortado.v1.AdminSetVolumeTrialThresholdResponse.
 * Use `create(AdminSetVolumeTrialThresholdResponseSchema)` to create a new message.
 */
export const AdminSetVolumeTrialThresholdResponseSchema: GenMessage<AdminSetVolumeTrialThresholdResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 114);

/**
 * AdminEndTrialNow ends the organization's Stripe trial immediately, which
 * charges the first invoice.
 *
 * @generated from message cortado.v1.AdminEndTrialNowRequest
 */
export type AdminEndTrialNowRequest = Message<"cortado.v1.AdminEndTrialNowRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message cortado.v1.AdminEndTrialNowRequest.
 * Use `create(AdminEndTrialNowRequestSchema)` to create a new message.
 */
export const AdminEndTrialNowRequestSchema: GenMessage<AdminEndTrialNowRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 115);

/**
 * @generated from message cortado.v1.AdminEndTrialNowResponse
 */
export type AdminEndTrialNowResponse = Message<"cortado.v1.AdminEndTrialNowResponse"> & {
  /**
   * @generated from field: cortado.v1.OrgBillingDetail billing = 1;
   */
  billing?: OrgBillingDetail;
};

/**
 * Describes the message cortado.v1.AdminEndTrialNowResponse.
 * Use `create(AdminEndTrialNowResponseSchema)` to create a new message.
 */
export const AdminEndTrialNowResponseSchema: GenMessage<AdminEndTrialNowResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 116);

/**
 * AdminResetTrialEligibility clears trial_used_at (R-31) - the only way a
 * former customer gets a second trial.
 *
 * @generated from message cortado.v1.AdminResetTrialEligibilityRequest
 */
export type AdminResetTrialEligibilityRequest = Message<"cortado.v1.AdminResetTrialEligibilityRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message cortado.v1.AdminResetTrialEligibilityRequest.
 * Use `create(AdminResetTrialEligibilityRequestSchema)` to create a new message.
 */
export const AdminResetTrialEligibilityRequestSchema: GenMessage<AdminResetTrialEligibilityRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 117);

/**
 * @generated from message cortado.v1.AdminResetTrialEligibilityResponse
 */
export type AdminResetTrialEligibilityResponse = Message<"cortado.v1.AdminResetTrialEligibilityResponse"> & {
  /**
   * @generated from field: cortado.v1.OrgBillingDetail billing = 1;
   */
  billing?: OrgBillingDetail;
};

/**
 * Describes the message cortado.v1.AdminResetTrialEligibilityResponse.
 * Use `create(AdminResetTrialEligibilityResponseSchema)` to create a new message.
 */
export const AdminResetTrialEligibilityResponseSchema: GenMessage<AdminResetTrialEligibilityResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 118);

/**
 * AdminAssignPlan sets an organization's assigned plan (R-71, R-80).
 *
 * @generated from message cortado.v1.AdminAssignPlanRequest
 */
export type AdminAssignPlanRequest = Message<"cortado.v1.AdminAssignPlanRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.PlanKeyEnum plan_key = 2;
   */
  planKey: PlanKeyEnum;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message cortado.v1.AdminAssignPlanRequest.
 * Use `create(AdminAssignPlanRequestSchema)` to create a new message.
 */
export const AdminAssignPlanRequestSchema: GenMessage<AdminAssignPlanRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 119);

/**
 * @generated from message cortado.v1.AdminAssignPlanResponse
 */
export type AdminAssignPlanResponse = Message<"cortado.v1.AdminAssignPlanResponse"> & {
  /**
   * @generated from field: cortado.v1.OrgBillingDetail billing = 1;
   */
  billing?: OrgBillingDetail;
};

/**
 * Describes the message cortado.v1.AdminAssignPlanResponse.
 * Use `create(AdminAssignPlanResponseSchema)` to create a new message.
 */
export const AdminAssignPlanResponseSchema: GenMessage<AdminAssignPlanResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 120);

/**
 * AdminSetPlanEligibility upserts a Founder or CCC eligibility list row
 * (R-74, R-82). Always writes status_read_at = now.
 *
 * @generated from message cortado.v1.AdminSetPlanEligibilityRequest
 */
export type AdminSetPlanEligibilityRequest = Message<"cortado.v1.AdminSetPlanEligibilityRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * "founder" | "ccc"
   *
   * @generated from field: string list_kind = 2;
   */
  listKind: string;

  /**
   * "active" | "inactive" | "unverified"
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: optional string notes = 4;
   */
  notes?: string;
};

/**
 * Describes the message cortado.v1.AdminSetPlanEligibilityRequest.
 * Use `create(AdminSetPlanEligibilityRequestSchema)` to create a new message.
 */
export const AdminSetPlanEligibilityRequestSchema: GenMessage<AdminSetPlanEligibilityRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 121);

/**
 * @generated from message cortado.v1.AdminSetPlanEligibilityResponse
 */
export type AdminSetPlanEligibilityResponse = Message<"cortado.v1.AdminSetPlanEligibilityResponse"> & {
  /**
   * @generated from field: cortado.v1.PlanEligibility plan_eligibility = 1;
   */
  planEligibility?: PlanEligibility;
};

/**
 * Describes the message cortado.v1.AdminSetPlanEligibilityResponse.
 * Use `create(AdminSetPlanEligibilityResponseSchema)` to create a new message.
 */
export const AdminSetPlanEligibilityResponseSchema: GenMessage<AdminSetPlanEligibilityResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 122);

/**
 * AdminListPlanEligibility lists Founder and/or CCC eligibility rows,
 * optionally filtered.
 *
 * @generated from message cortado.v1.AdminListPlanEligibilityRequest
 */
export type AdminListPlanEligibilityRequest = Message<"cortado.v1.AdminListPlanEligibilityRequest"> & {
  /**
   * @generated from field: optional string list_kind = 1;
   */
  listKind?: string;

  /**
   * @generated from field: optional string status = 2;
   */
  status?: string;
};

/**
 * Describes the message cortado.v1.AdminListPlanEligibilityRequest.
 * Use `create(AdminListPlanEligibilityRequestSchema)` to create a new message.
 */
export const AdminListPlanEligibilityRequestSchema: GenMessage<AdminListPlanEligibilityRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 123);

/**
 * @generated from message cortado.v1.AdminListPlanEligibilityResponse
 */
export type AdminListPlanEligibilityResponse = Message<"cortado.v1.AdminListPlanEligibilityResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.PlanEligibility plan_eligibility = 1;
   */
  planEligibility: PlanEligibility[];
};

/**
 * Describes the message cortado.v1.AdminListPlanEligibilityResponse.
 * Use `create(AdminListPlanEligibilityResponseSchema)` to create a new message.
 */
export const AdminListPlanEligibilityResponseSchema: GenMessage<AdminListPlanEligibilityResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 124);

/**
 * AdminInviteAccount provisions an account for a new customer: it creates the
 * user and their organization, records the plan the organization is eligible
 * for, grants the chosen trial, and emails a sign-in link. The trial clock
 * starts when the owner enters a card at checkout.
 *
 * @generated from message cortado.v1.AdminInviteAccountRequest
 */
export type AdminInviteAccountRequest = Message<"cortado.v1.AdminInviteAccountRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * @generated from field: string company_name = 4;
   */
  companyName: string;

  /**
   * PLAN_KEY_STANDARD or PLAN_KEY_CCC.
   *
   * @generated from field: cortado.v1.PlanKeyEnum plan = 5;
   */
  plan: PlanKeyEnum;

  /**
   * @generated from oneof cortado.v1.AdminInviteAccountRequest.trial
   */
  trial: {
    /**
     * @generated from field: cortado.v1.InviteStandardTrial standard_trial = 6;
     */
    value: InviteStandardTrial;
    case: "standardTrial";
  } | {
    /**
     * @generated from field: cortado.v1.InviteExtendedTrial extended_trial = 7;
     */
    value: InviteExtendedTrial;
    case: "extendedTrial";
  } | {
    /**
     * @generated from field: cortado.v1.InviteVolumeTrial volume_trial = 9;
     */
    value: InviteVolumeTrial;
    case: "volumeTrial";
  } | { case: undefined; value?: undefined };

  /**
   * Why the account gets this plan or trial. Required unless both are standard.
   *
   * @generated from field: string reason = 8;
   */
  reason: string;
};

/**
 * Describes the message cortado.v1.AdminInviteAccountRequest.
 * Use `create(AdminInviteAccountRequestSchema)` to create a new message.
 */
export const AdminInviteAccountRequestSchema: GenMessage<AdminInviteAccountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 125);

/**
 * InviteStandardTrial is the configured BILLING_TRIAL_DAYS trial.
 *
 * @generated from message cortado.v1.InviteStandardTrial
 */
export type InviteStandardTrial = Message<"cortado.v1.InviteStandardTrial"> & {
};

/**
 * Describes the message cortado.v1.InviteStandardTrial.
 * Use `create(InviteStandardTrialSchema)` to create a new message.
 */
export const InviteStandardTrialSchema: GenMessage<InviteStandardTrial> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 126);

/**
 * InviteExtendedTrial replaces the standard trial with a fixed length.
 *
 * @generated from message cortado.v1.InviteExtendedTrial
 */
export type InviteExtendedTrial = Message<"cortado.v1.InviteExtendedTrial"> & {
  /**
   * @generated from field: int32 days = 1;
   */
  days: number;
};

/**
 * Describes the message cortado.v1.InviteExtendedTrial.
 * Use `create(InviteExtendedTrialSchema)` to create a new message.
 */
export const InviteExtendedTrialSchema: GenMessage<InviteExtendedTrial> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 127);

/**
 * InviteVolumeTrial ends the trial once the organization has processed
 * threshold_cents through Stripe Connect, or after backstop_days, whichever
 * comes first.
 *
 * @generated from message cortado.v1.InviteVolumeTrial
 */
export type InviteVolumeTrial = Message<"cortado.v1.InviteVolumeTrial"> & {
  /**
   * @generated from field: int64 threshold_cents = 1;
   */
  thresholdCents: bigint;

  /**
   * @generated from field: int32 backstop_days = 2;
   */
  backstopDays: number;
};

/**
 * Describes the message cortado.v1.InviteVolumeTrial.
 * Use `create(InviteVolumeTrialSchema)` to create a new message.
 */
export const InviteVolumeTrialSchema: GenMessage<InviteVolumeTrial> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 128);

/**
 * @generated from message cortado.v1.AdminInviteAccountResponse
 */
export type AdminInviteAccountResponse = Message<"cortado.v1.AdminInviteAccountResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * The trial length, or a volume trial's backstop.
   *
   * @generated from field: int32 trial_days = 3;
   */
  trialDays: number;
};

/**
 * Describes the message cortado.v1.AdminInviteAccountResponse.
 * Use `create(AdminInviteAccountResponseSchema)` to create a new message.
 */
export const AdminInviteAccountResponseSchema: GenMessage<AdminInviteAccountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 129);

/**
 * AdminCreateRateException records an approved base-price exception (R-80,
 * §29). amount_cents only - no discount_kind, no basis_points: a percentage
 * cannot be scoped to the base price alone (R-106), so it is not expressible.
 *
 * @generated from message cortado.v1.AdminCreateRateExceptionRequest
 */
export type AdminCreateRateExceptionRequest = Message<"cortado.v1.AdminCreateRateExceptionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string account_name = 2;
   */
  accountName: string;

  /**
   * @generated from field: string approved_rate_description = 3;
   */
  approvedRateDescription: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * @generated from field: google.protobuf.Timestamp effective_date = 5;
   */
  effectiveDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration_date = 6;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: string approver_name = 7;
   */
  approverName: string;

  /**
   * @generated from field: string approval_reference = 8;
   */
  approvalReference: string;

  /**
   * amount_cents is a PER-MONTH discount. Cortado multiplies it by each
   * product's interval_months to derive that product's Stripe coupon - see
   * RateException.amount_cents.
   *
   * @generated from field: int64 amount_cents = 9;
   */
  amountCents: bigint;

  /**
   * seat_coverage_cents is also PER-MONTH and multiplied by interval_months
   * the same way; leave unset unless the approved rate specifically also
   * covers additional-seat charges (R-106).
   *
   * @generated from field: optional int64 seat_coverage_cents = 10;
   */
  seatCoverageCents?: bigint;
};

/**
 * Describes the message cortado.v1.AdminCreateRateExceptionRequest.
 * Use `create(AdminCreateRateExceptionRequestSchema)` to create a new message.
 */
export const AdminCreateRateExceptionRequestSchema: GenMessage<AdminCreateRateExceptionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 130);

/**
 * @generated from message cortado.v1.AdminCreateRateExceptionResponse
 */
export type AdminCreateRateExceptionResponse = Message<"cortado.v1.AdminCreateRateExceptionResponse"> & {
  /**
   * @generated from field: cortado.v1.RateException rate_exception = 1;
   */
  rateException?: RateException;
};

/**
 * Describes the message cortado.v1.AdminCreateRateExceptionResponse.
 * Use `create(AdminCreateRateExceptionResponseSchema)` to create a new message.
 */
export const AdminCreateRateExceptionResponseSchema: GenMessage<AdminCreateRateExceptionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 131);

/**
 * AdminListRateExceptions lists rate/trial exception records, optionally
 * filtered by organization and/or status.
 *
 * @generated from message cortado.v1.AdminListRateExceptionsRequest
 */
export type AdminListRateExceptionsRequest = Message<"cortado.v1.AdminListRateExceptionsRequest"> & {
  /**
   * @generated from field: optional string organization_id = 1;
   */
  organizationId?: string;

  /**
   * @generated from field: optional string status = 2;
   */
  status?: string;

  /**
   * "rate" | "trial"
   *
   * @generated from field: optional string exception_kind = 3;
   */
  exceptionKind?: string;
};

/**
 * Describes the message cortado.v1.AdminListRateExceptionsRequest.
 * Use `create(AdminListRateExceptionsRequestSchema)` to create a new message.
 */
export const AdminListRateExceptionsRequestSchema: GenMessage<AdminListRateExceptionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 132);

/**
 * @generated from message cortado.v1.AdminListRateExceptionsResponse
 */
export type AdminListRateExceptionsResponse = Message<"cortado.v1.AdminListRateExceptionsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.RateException rate_exceptions = 1;
   */
  rateExceptions: RateException[];
};

/**
 * Describes the message cortado.v1.AdminListRateExceptionsResponse.
 * Use `create(AdminListRateExceptionsResponseSchema)` to create a new message.
 */
export const AdminListRateExceptionsResponseSchema: GenMessage<AdminListRateExceptionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 133);

/**
 * AdminRevokeRateException revokes a rate/trial exception record.
 *
 * @generated from message cortado.v1.AdminRevokeRateExceptionRequest
 */
export type AdminRevokeRateExceptionRequest = Message<"cortado.v1.AdminRevokeRateExceptionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message cortado.v1.AdminRevokeRateExceptionRequest.
 * Use `create(AdminRevokeRateExceptionRequestSchema)` to create a new message.
 */
export const AdminRevokeRateExceptionRequestSchema: GenMessage<AdminRevokeRateExceptionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 134);

/**
 * @generated from message cortado.v1.AdminRevokeRateExceptionResponse
 */
export type AdminRevokeRateExceptionResponse = Message<"cortado.v1.AdminRevokeRateExceptionResponse"> & {
  /**
   * @generated from field: cortado.v1.RateException rate_exception = 1;
   */
  rateException?: RateException;
};

/**
 * Describes the message cortado.v1.AdminRevokeRateExceptionResponse.
 * Use `create(AdminRevokeRateExceptionResponseSchema)` to create a new message.
 */
export const AdminRevokeRateExceptionResponseSchema: GenMessage<AdminRevokeRateExceptionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 135);

/**
 * AdminSetAccessOverride creates a comp, whitelist, or suspend override
 * (R-73, R-83).
 *
 * @generated from message cortado.v1.AdminSetAccessOverrideRequest
 */
export type AdminSetAccessOverrideRequest = Message<"cortado.v1.AdminSetAccessOverrideRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * "comp" | "whitelist" | "suspend"
   *
   * @generated from field: string override_kind = 2;
   */
  overrideKind: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp ends_at = 4;
   */
  endsAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.AdminSetAccessOverrideRequest.
 * Use `create(AdminSetAccessOverrideRequestSchema)` to create a new message.
 */
export const AdminSetAccessOverrideRequestSchema: GenMessage<AdminSetAccessOverrideRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 136);

/**
 * @generated from message cortado.v1.AdminSetAccessOverrideResponse
 */
export type AdminSetAccessOverrideResponse = Message<"cortado.v1.AdminSetAccessOverrideResponse"> & {
  /**
   * @generated from field: cortado.v1.AccessOverride access_override = 1;
   */
  accessOverride?: AccessOverride;
};

/**
 * Describes the message cortado.v1.AdminSetAccessOverrideResponse.
 * Use `create(AdminSetAccessOverrideResponseSchema)` to create a new message.
 */
export const AdminSetAccessOverrideResponseSchema: GenMessage<AdminSetAccessOverrideResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 137);

/**
 * AdminRevokeAccessOverride revokes an access override by id.
 *
 * @generated from message cortado.v1.AdminRevokeAccessOverrideRequest
 */
export type AdminRevokeAccessOverrideRequest = Message<"cortado.v1.AdminRevokeAccessOverrideRequest"> & {
  /**
   * @generated from field: string override_id = 1;
   */
  overrideId: string;
};

/**
 * Describes the message cortado.v1.AdminRevokeAccessOverrideRequest.
 * Use `create(AdminRevokeAccessOverrideRequestSchema)` to create a new message.
 */
export const AdminRevokeAccessOverrideRequestSchema: GenMessage<AdminRevokeAccessOverrideRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 138);

/**
 * @generated from message cortado.v1.AdminRevokeAccessOverrideResponse
 */
export type AdminRevokeAccessOverrideResponse = Message<"cortado.v1.AdminRevokeAccessOverrideResponse"> & {
};

/**
 * Describes the message cortado.v1.AdminRevokeAccessOverrideResponse.
 * Use `create(AdminRevokeAccessOverrideResponseSchema)` to create a new message.
 */
export const AdminRevokeAccessOverrideResponseSchema: GenMessage<AdminRevokeAccessOverrideResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 139);

/**
 * AdminForceCancelSubscription force-cancels an organization's subscription.
 * immediate=true revokes access now instead of at period end (R-53).
 *
 * @generated from message cortado.v1.AdminForceCancelSubscriptionRequest
 */
export type AdminForceCancelSubscriptionRequest = Message<"cortado.v1.AdminForceCancelSubscriptionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: bool immediate = 2;
   */
  immediate: boolean;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message cortado.v1.AdminForceCancelSubscriptionRequest.
 * Use `create(AdminForceCancelSubscriptionRequestSchema)` to create a new message.
 */
export const AdminForceCancelSubscriptionRequestSchema: GenMessage<AdminForceCancelSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 140);

/**
 * @generated from message cortado.v1.AdminForceCancelSubscriptionResponse
 */
export type AdminForceCancelSubscriptionResponse = Message<"cortado.v1.AdminForceCancelSubscriptionResponse"> & {
  /**
   * @generated from field: cortado.v1.OrgBillingDetail billing = 1;
   */
  billing?: OrgBillingDetail;
};

/**
 * Describes the message cortado.v1.AdminForceCancelSubscriptionResponse.
 * Use `create(AdminForceCancelSubscriptionResponseSchema)` to create a new message.
 */
export const AdminForceCancelSubscriptionResponseSchema: GenMessage<AdminForceCancelSubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 141);

/**
 * AdminGetBillingLaunchConfig retrieves the singleton billing-launch config.
 *
 * @generated from message cortado.v1.AdminGetBillingLaunchConfigRequest
 */
export type AdminGetBillingLaunchConfigRequest = Message<"cortado.v1.AdminGetBillingLaunchConfigRequest"> & {
};

/**
 * Describes the message cortado.v1.AdminGetBillingLaunchConfigRequest.
 * Use `create(AdminGetBillingLaunchConfigRequestSchema)` to create a new message.
 */
export const AdminGetBillingLaunchConfigRequestSchema: GenMessage<AdminGetBillingLaunchConfigRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 142);

/**
 * @generated from message cortado.v1.AdminGetBillingLaunchConfigResponse
 */
export type AdminGetBillingLaunchConfigResponse = Message<"cortado.v1.AdminGetBillingLaunchConfigResponse"> & {
  /**
   * @generated from field: cortado.v1.BillingLaunchConfig config = 1;
   */
  config?: BillingLaunchConfig;

  /**
   * @generated from field: google.protobuf.Timestamp server_time = 2;
   */
  serverTime?: Timestamp;

  /**
   * @generated from field: bool locked = 3;
   */
  locked: boolean;
};

/**
 * Describes the message cortado.v1.AdminGetBillingLaunchConfigResponse.
 * Use `create(AdminGetBillingLaunchConfigResponseSchema)` to create a new message.
 */
export const AdminGetBillingLaunchConfigResponseSchema: GenMessage<AdminGetBillingLaunchConfigResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 143);

/**
 * AdminUpdateBillingLaunchConfig updates the singleton billing-launch config.
 *
 * @generated from message cortado.v1.AdminUpdateBillingLaunchConfigRequest
 */
export type AdminUpdateBillingLaunchConfigRequest = Message<"cortado.v1.AdminUpdateBillingLaunchConfigRequest"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp billing_launch_at = 2;
   */
  billingLaunchAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.AdminUpdateBillingLaunchConfigRequest.
 * Use `create(AdminUpdateBillingLaunchConfigRequestSchema)` to create a new message.
 */
export const AdminUpdateBillingLaunchConfigRequestSchema: GenMessage<AdminUpdateBillingLaunchConfigRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 144);

/**
 * @generated from message cortado.v1.AdminUpdateBillingLaunchConfigResponse
 */
export type AdminUpdateBillingLaunchConfigResponse = Message<"cortado.v1.AdminUpdateBillingLaunchConfigResponse"> & {
  /**
   * @generated from field: cortado.v1.BillingLaunchConfig config = 1;
   */
  config?: BillingLaunchConfig;
};

/**
 * Describes the message cortado.v1.AdminUpdateBillingLaunchConfigResponse.
 * Use `create(AdminUpdateBillingLaunchConfigResponseSchema)` to create a new message.
 */
export const AdminUpdateBillingLaunchConfigResponseSchema: GenMessage<AdminUpdateBillingLaunchConfigResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 145);

/**
 * AdminResyncSeats re-derives an organization's desired seat count and
 * repairs any drift against the applied Stripe subscription quantity.
 *
 * @generated from message cortado.v1.AdminResyncSeatsRequest
 */
export type AdminResyncSeatsRequest = Message<"cortado.v1.AdminResyncSeatsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.AdminResyncSeatsRequest.
 * Use `create(AdminResyncSeatsRequestSchema)` to create a new message.
 */
export const AdminResyncSeatsRequestSchema: GenMessage<AdminResyncSeatsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 146);

/**
 * @generated from message cortado.v1.AdminResyncSeatsResponse
 */
export type AdminResyncSeatsResponse = Message<"cortado.v1.AdminResyncSeatsResponse"> & {
  /**
   * @generated from field: int32 desired_seats = 1;
   */
  desiredSeats: number;

  /**
   * @generated from field: int32 applied_seats = 2;
   */
  appliedSeats: number;
};

/**
 * Describes the message cortado.v1.AdminResyncSeatsResponse.
 * Use `create(AdminResyncSeatsResponseSchema)` to create a new message.
 */
export const AdminResyncSeatsResponseSchema: GenMessage<AdminResyncSeatsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 147);

/**
 * AdminListRetentionDue returns the R-56 manual data-deletion queue.
 *
 * @generated from message cortado.v1.AdminListRetentionDueRequest
 */
export type AdminListRetentionDueRequest = Message<"cortado.v1.AdminListRetentionDueRequest"> & {
};

/**
 * Describes the message cortado.v1.AdminListRetentionDueRequest.
 * Use `create(AdminListRetentionDueRequestSchema)` to create a new message.
 */
export const AdminListRetentionDueRequestSchema: GenMessage<AdminListRetentionDueRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 148);

/**
 * @generated from message cortado.v1.AdminListRetentionDueResponse
 */
export type AdminListRetentionDueResponse = Message<"cortado.v1.AdminListRetentionDueResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.RetentionDueRow retention_due = 1;
   */
  retentionDue: RetentionDueRow[];
};

/**
 * Describes the message cortado.v1.AdminListRetentionDueResponse.
 * Use `create(AdminListRetentionDueResponseSchema)` to create a new message.
 */
export const AdminListRetentionDueResponseSchema: GenMessage<AdminListRetentionDueResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 149);

/**
 * AdminResyncBillingState re-reads an organization's Stripe subscription (and
 * latest checkout if it has no subscription) and reapplies the billing state.
 * Idempotent; safe to run on any org. Lost-webhook-recovery and
 * illegal-transition-drift remediation (DEC-37).
 *
 * @generated from message cortado.v1.AdminResyncBillingStateRequest
 */
export type AdminResyncBillingStateRequest = Message<"cortado.v1.AdminResyncBillingStateRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.AdminResyncBillingStateRequest.
 * Use `create(AdminResyncBillingStateRequestSchema)` to create a new message.
 */
export const AdminResyncBillingStateRequestSchema: GenMessage<AdminResyncBillingStateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 150);

/**
 * @generated from message cortado.v1.AdminResyncBillingStateResponse
 */
export type AdminResyncBillingStateResponse = Message<"cortado.v1.AdminResyncBillingStateResponse"> & {
  /**
   * @generated from field: cortado.v1.OrgBillingDetail billing = 1;
   */
  billing?: OrgBillingDetail;
};

/**
 * Describes the message cortado.v1.AdminResyncBillingStateResponse.
 * Use `create(AdminResyncBillingStateResponseSchema)` to create a new message.
 */
export const AdminResyncBillingStateResponseSchema: GenMessage<AdminResyncBillingStateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 151);

/**
 * SupportSession is a time-boxed grant that lets a Cortado superadmin work
 * inside one tenant organization with every permission except Admin, Team
 * management and Billing. It adds no organization membership, so the tenant
 * never sees it and it never counts as a seat.
 *
 * @generated from message cortado.v1.SupportSession
 */
export type SupportSession = Message<"cortado.v1.SupportSession"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId: string;

  /**
   * @generated from field: string admin_email = 3;
   */
  adminEmail: string;

  /**
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;

  /**
   * @generated from field: string organization_name = 5;
   */
  organizationName: string;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 8;
   */
  expiresAt?: Timestamp;

  /**
   * Unset while the session is open; set when it was ended early or replaced.
   *
   * @generated from field: optional google.protobuf.Timestamp ended_at = 9;
   */
  endedAt?: Timestamp;

  /**
   * True while ended_at is unset and expires_at is in the future.
   *
   * @generated from field: bool active = 10;
   */
  active: boolean;

  /**
   * Permission keys the session grants in the organization (same strings as
   * OrganizationUser.effective_permissions). Never includes Admin,
   * TeamManage or BillingManage.
   *
   * @generated from field: repeated string permissions = 11;
   */
  permissions: string[];
};

/**
 * Describes the message cortado.v1.SupportSession.
 * Use `create(SupportSessionSchema)` to create a new message.
 */
export const SupportSessionSchema: GenMessage<SupportSession> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 152);

/**
 * StartSupportSessionRequest opens a session for the calling superadmin.
 * Any open session the caller already has for this organization is ended first.
 *
 * @generated from message cortado.v1.StartSupportSessionRequest
 */
export type StartSupportSessionRequest = Message<"cortado.v1.StartSupportSessionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Why the session is needed. Required, kept in the session log.
   *
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: cortado.v1.SupportSessionDuration duration = 3;
   */
  duration: SupportSessionDuration;
};

/**
 * Describes the message cortado.v1.StartSupportSessionRequest.
 * Use `create(StartSupportSessionRequestSchema)` to create a new message.
 */
export const StartSupportSessionRequestSchema: GenMessage<StartSupportSessionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 153);

/**
 * @generated from message cortado.v1.StartSupportSessionResponse
 */
export type StartSupportSessionResponse = Message<"cortado.v1.StartSupportSessionResponse"> & {
  /**
   * @generated from field: cortado.v1.SupportSession session = 1;
   */
  session?: SupportSession;
};

/**
 * Describes the message cortado.v1.StartSupportSessionResponse.
 * Use `create(StartSupportSessionResponseSchema)` to create a new message.
 */
export const StartSupportSessionResponseSchema: GenMessage<StartSupportSessionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 154);

/**
 * EndSupportSessionRequest ends a session early. Any superadmin may end any session.
 *
 * @generated from message cortado.v1.EndSupportSessionRequest
 */
export type EndSupportSessionRequest = Message<"cortado.v1.EndSupportSessionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.EndSupportSessionRequest.
 * Use `create(EndSupportSessionRequestSchema)` to create a new message.
 */
export const EndSupportSessionRequestSchema: GenMessage<EndSupportSessionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 155);

/**
 * @generated from message cortado.v1.EndSupportSessionResponse
 */
export type EndSupportSessionResponse = Message<"cortado.v1.EndSupportSessionResponse"> & {
  /**
   * @generated from field: cortado.v1.SupportSession session = 1;
   */
  session?: SupportSession;
};

/**
 * Describes the message cortado.v1.EndSupportSessionResponse.
 * Use `create(EndSupportSessionResponseSchema)` to create a new message.
 */
export const EndSupportSessionResponseSchema: GenMessage<EndSupportSessionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 156);

/**
 * ListSupportSessionsRequest lists sessions, newest first.
 *
 * @generated from message cortado.v1.ListSupportSessionsRequest
 */
export type ListSupportSessionsRequest = Message<"cortado.v1.ListSupportSessionsRequest"> & {
  /**
   * @generated from field: optional string organization_id = 1;
   */
  organizationId?: string;

  /**
   * @generated from field: bool active_only = 2;
   */
  activeOnly: boolean;

  /**
   * Defaults to 50, capped at 200.
   *
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message cortado.v1.ListSupportSessionsRequest.
 * Use `create(ListSupportSessionsRequestSchema)` to create a new message.
 */
export const ListSupportSessionsRequestSchema: GenMessage<ListSupportSessionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 157);

/**
 * @generated from message cortado.v1.ListSupportSessionsResponse
 */
export type ListSupportSessionsResponse = Message<"cortado.v1.ListSupportSessionsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.SupportSession sessions = 1;
   */
  sessions: SupportSession[];
};

/**
 * Describes the message cortado.v1.ListSupportSessionsResponse.
 * Use `create(ListSupportSessionsResponseSchema)` to create a new message.
 */
export const ListSupportSessionsResponseSchema: GenMessage<ListSupportSessionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 158);

/**
 * ListMySupportSessionsRequest lists the caller's own active support sessions.
 * Callable by any authenticated user; non-superadmins always get an empty list.
 *
 * @generated from message cortado.v1.ListMySupportSessionsRequest
 */
export type ListMySupportSessionsRequest = Message<"cortado.v1.ListMySupportSessionsRequest"> & {
};

/**
 * Describes the message cortado.v1.ListMySupportSessionsRequest.
 * Use `create(ListMySupportSessionsRequestSchema)` to create a new message.
 */
export const ListMySupportSessionsRequestSchema: GenMessage<ListMySupportSessionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 159);

/**
 * @generated from message cortado.v1.ListMySupportSessionsResponse
 */
export type ListMySupportSessionsResponse = Message<"cortado.v1.ListMySupportSessionsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.SupportSession sessions = 1;
   */
  sessions: SupportSession[];
};

/**
 * Describes the message cortado.v1.ListMySupportSessionsResponse.
 * Use `create(ListMySupportSessionsResponseSchema)` to create a new message.
 */
export const ListMySupportSessionsResponseSchema: GenMessage<ListMySupportSessionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_admin, 160);

/**
 * SupportSessionDuration is how long a superadmin support session lasts.
 *
 * @generated from enum cortado.v1.SupportSessionDuration
 */
export enum SupportSessionDuration {
  /**
   * @generated from enum value: SUPPORT_SESSION_DURATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORT_SESSION_DURATION_ONE_HOUR = 1;
   */
  ONE_HOUR = 1,

  /**
   * @generated from enum value: SUPPORT_SESSION_DURATION_FOUR_HOURS = 2;
   */
  FOUR_HOURS = 2,

  /**
   * @generated from enum value: SUPPORT_SESSION_DURATION_EIGHT_HOURS = 3;
   */
  EIGHT_HOURS = 3,
}

/**
 * Describes the enum cortado.v1.SupportSessionDuration.
 */
export const SupportSessionDurationSchema: GenEnum<SupportSessionDuration> = /*@__PURE__*/
  enumDesc(file_cortado_v1_admin, 0);

/**
 * @generated from service cortado.v1.AdminService
 */
export const AdminService: GenService<{
  /**
   * @generated from rpc cortado.v1.AdminService.VerifyAdmin
   */
  verifyAdmin: {
    methodKind: "unary";
    input: typeof VerifyAdminRequestSchema;
    output: typeof VerifyAdminResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.ListAdmins
   */
  listAdmins: {
    methodKind: "unary";
    input: typeof ListAdminsRequestSchema;
    output: typeof ListAdminsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.CreateAnnouncement
   */
  createAnnouncement: {
    methodKind: "unary";
    input: typeof CreateAnnouncementRequestSchema;
    output: typeof CreateAnnouncementResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.ListAnnouncements
   */
  listAnnouncements: {
    methodKind: "unary";
    input: typeof ListAnnouncementsRequestSchema;
    output: typeof ListAnnouncementsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.ListAnnouncementReads
   */
  listAnnouncementReads: {
    methodKind: "unary";
    input: typeof ListAnnouncementReadsRequestSchema;
    output: typeof ListAnnouncementReadsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.ArchiveAnnouncement
   */
  archiveAnnouncement: {
    methodKind: "unary";
    input: typeof ArchiveAnnouncementRequestSchema;
    output: typeof ArchiveAnnouncementResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.GetEmailMarketingOverview
   */
  getEmailMarketingOverview: {
    methodKind: "unary";
    input: typeof GetEmailMarketingOverviewRequestSchema;
    output: typeof GetEmailMarketingOverviewResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.SyncEmailMarketingContacts
   */
  syncEmailMarketingContacts: {
    methodKind: "unary";
    input: typeof SyncEmailMarketingContactsRequestSchema;
    output: typeof SyncEmailMarketingContactsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.RepairEmailMarketingResources
   */
  repairEmailMarketingResources: {
    methodKind: "unary";
    input: typeof RepairEmailMarketingResourcesRequestSchema;
    output: typeof RepairEmailMarketingResourcesResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.ListEmailMarketingResources
   */
  listEmailMarketingResources: {
    methodKind: "unary";
    input: typeof ListEmailMarketingResourcesRequestSchema;
    output: typeof ListEmailMarketingResourcesResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.CreateEmailMarketingResource
   */
  createEmailMarketingResource: {
    methodKind: "unary";
    input: typeof CreateEmailMarketingResourceRequestSchema;
    output: typeof CreateEmailMarketingResourceResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.ListEmailMarketingCampaigns
   */
  listEmailMarketingCampaigns: {
    methodKind: "unary";
    input: typeof ListEmailMarketingCampaignsRequestSchema;
    output: typeof ListEmailMarketingCampaignsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.GetEmailMarketingCampaign
   */
  getEmailMarketingCampaign: {
    methodKind: "unary";
    input: typeof GetEmailMarketingCampaignRequestSchema;
    output: typeof GetEmailMarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.CreateEmailMarketingCampaign
   */
  createEmailMarketingCampaign: {
    methodKind: "unary";
    input: typeof CreateEmailMarketingCampaignRequestSchema;
    output: typeof CreateEmailMarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.UpdateEmailMarketingCampaign
   */
  updateEmailMarketingCampaign: {
    methodKind: "unary";
    input: typeof UpdateEmailMarketingCampaignRequestSchema;
    output: typeof UpdateEmailMarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.SendEmailMarketingCampaignTest
   */
  sendEmailMarketingCampaignTest: {
    methodKind: "unary";
    input: typeof SendEmailMarketingCampaignTestRequestSchema;
    output: typeof SendEmailMarketingCampaignTestResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.LaunchEmailMarketingCampaign
   */
  launchEmailMarketingCampaign: {
    methodKind: "unary";
    input: typeof LaunchEmailMarketingCampaignRequestSchema;
    output: typeof LaunchEmailMarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.RefreshEmailMarketingCampaignStatus
   */
  refreshEmailMarketingCampaignStatus: {
    methodKind: "unary";
    input: typeof RefreshEmailMarketingCampaignStatusRequestSchema;
    output: typeof RefreshEmailMarketingCampaignStatusResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.GetSystemSettings
   */
  getSystemSettings: {
    methodKind: "unary";
    input: typeof GetSystemSettingsAdminRequestSchema;
    output: typeof GetSystemSettingsAdminResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.UpdateSystemSettings
   */
  updateSystemSettings: {
    methodKind: "unary";
    input: typeof UpdateSystemSettingsRequestSchema;
    output: typeof UpdateSystemSettingsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.GetAiOrbConfig
   */
  getAiOrbConfig: {
    methodKind: "unary";
    input: typeof GetAiOrbConfigAdminRequestSchema;
    output: typeof GetAiOrbConfigAdminResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.UpdateAiOrbConfig
   */
  updateAiOrbConfig: {
    methodKind: "unary";
    input: typeof UpdateAiOrbConfigRequestSchema;
    output: typeof UpdateAiOrbConfigResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.RequeueFailedWorkflowTriggerEvents
   */
  requeueFailedWorkflowTriggerEvents: {
    methodKind: "unary";
    input: typeof RequeueFailedWorkflowTriggerEventsRequestSchema;
    output: typeof RequeueFailedWorkflowTriggerEventsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.ResetWorkflowActionEffect
   */
  resetWorkflowActionEffect: {
    methodKind: "unary";
    input: typeof ResetWorkflowActionEffectRequestSchema;
    output: typeof ResetWorkflowActionEffectResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.ListFailedWorkflowTriggerEvents
   */
  listFailedWorkflowTriggerEvents: {
    methodKind: "unary";
    input: typeof ListFailedWorkflowTriggerEventsRequestSchema;
    output: typeof ListFailedWorkflowTriggerEventsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.RequeueWorkflowTriggerEvent
   */
  requeueWorkflowTriggerEvent: {
    methodKind: "unary";
    input: typeof RequeueWorkflowTriggerEventRequestSchema;
    output: typeof RequeueWorkflowTriggerEventResponseSchema;
  },
  /**
   * ==================== Billing v2 admin ====================
   *
   * @generated from rpc cortado.v1.AdminService.AdminListOrganizationBilling
   */
  adminListOrganizationBilling: {
    methodKind: "unary";
    input: typeof AdminListOrganizationBillingRequestSchema;
    output: typeof AdminListOrganizationBillingResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminGetOrganizationBilling
   */
  adminGetOrganizationBilling: {
    methodKind: "unary";
    input: typeof AdminGetOrganizationBillingRequestSchema;
    output: typeof AdminGetOrganizationBillingResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminSetBillingStartDate
   */
  adminSetBillingStartDate: {
    methodKind: "unary";
    input: typeof AdminSetBillingStartDateRequestSchema;
    output: typeof AdminSetBillingStartDateResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminSetVolumeTrialThreshold
   */
  adminSetVolumeTrialThreshold: {
    methodKind: "unary";
    input: typeof AdminSetVolumeTrialThresholdRequestSchema;
    output: typeof AdminSetVolumeTrialThresholdResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminEndTrialNow
   */
  adminEndTrialNow: {
    methodKind: "unary";
    input: typeof AdminEndTrialNowRequestSchema;
    output: typeof AdminEndTrialNowResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminResetTrialEligibility
   */
  adminResetTrialEligibility: {
    methodKind: "unary";
    input: typeof AdminResetTrialEligibilityRequestSchema;
    output: typeof AdminResetTrialEligibilityResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminAssignPlan
   */
  adminAssignPlan: {
    methodKind: "unary";
    input: typeof AdminAssignPlanRequestSchema;
    output: typeof AdminAssignPlanResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminSetPlanEligibility
   */
  adminSetPlanEligibility: {
    methodKind: "unary";
    input: typeof AdminSetPlanEligibilityRequestSchema;
    output: typeof AdminSetPlanEligibilityResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminListPlanEligibility
   */
  adminListPlanEligibility: {
    methodKind: "unary";
    input: typeof AdminListPlanEligibilityRequestSchema;
    output: typeof AdminListPlanEligibilityResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminInviteAccount
   */
  adminInviteAccount: {
    methodKind: "unary";
    input: typeof AdminInviteAccountRequestSchema;
    output: typeof AdminInviteAccountResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminCreateRateException
   */
  adminCreateRateException: {
    methodKind: "unary";
    input: typeof AdminCreateRateExceptionRequestSchema;
    output: typeof AdminCreateRateExceptionResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminListRateExceptions
   */
  adminListRateExceptions: {
    methodKind: "unary";
    input: typeof AdminListRateExceptionsRequestSchema;
    output: typeof AdminListRateExceptionsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminRevokeRateException
   */
  adminRevokeRateException: {
    methodKind: "unary";
    input: typeof AdminRevokeRateExceptionRequestSchema;
    output: typeof AdminRevokeRateExceptionResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminSetAccessOverride
   */
  adminSetAccessOverride: {
    methodKind: "unary";
    input: typeof AdminSetAccessOverrideRequestSchema;
    output: typeof AdminSetAccessOverrideResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminRevokeAccessOverride
   */
  adminRevokeAccessOverride: {
    methodKind: "unary";
    input: typeof AdminRevokeAccessOverrideRequestSchema;
    output: typeof AdminRevokeAccessOverrideResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminForceCancelSubscription
   */
  adminForceCancelSubscription: {
    methodKind: "unary";
    input: typeof AdminForceCancelSubscriptionRequestSchema;
    output: typeof AdminForceCancelSubscriptionResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminGetBillingLaunchConfig
   */
  adminGetBillingLaunchConfig: {
    methodKind: "unary";
    input: typeof AdminGetBillingLaunchConfigRequestSchema;
    output: typeof AdminGetBillingLaunchConfigResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminUpdateBillingLaunchConfig
   */
  adminUpdateBillingLaunchConfig: {
    methodKind: "unary";
    input: typeof AdminUpdateBillingLaunchConfigRequestSchema;
    output: typeof AdminUpdateBillingLaunchConfigResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminResyncSeats
   */
  adminResyncSeats: {
    methodKind: "unary";
    input: typeof AdminResyncSeatsRequestSchema;
    output: typeof AdminResyncSeatsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminListRetentionDue
   */
  adminListRetentionDue: {
    methodKind: "unary";
    input: typeof AdminListRetentionDueRequestSchema;
    output: typeof AdminListRetentionDueResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminResyncBillingState
   */
  adminResyncBillingState: {
    methodKind: "unary";
    input: typeof AdminResyncBillingStateRequestSchema;
    output: typeof AdminResyncBillingStateResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.AdminGetPlatformRevenueMetrics
   */
  adminGetPlatformRevenueMetrics: {
    methodKind: "unary";
    input: typeof AdminGetPlatformRevenueMetricsRequestSchema;
    output: typeof AdminGetPlatformRevenueMetricsResponseSchema;
  },
  /**
   * ==================== Support sessions ====================
   *
   * @generated from rpc cortado.v1.AdminService.StartSupportSession
   */
  startSupportSession: {
    methodKind: "unary";
    input: typeof StartSupportSessionRequestSchema;
    output: typeof StartSupportSessionResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.EndSupportSession
   */
  endSupportSession: {
    methodKind: "unary";
    input: typeof EndSupportSessionRequestSchema;
    output: typeof EndSupportSessionResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AdminService.ListSupportSessions
   */
  listSupportSessions: {
    methodKind: "unary";
    input: typeof ListSupportSessionsRequestSchema;
    output: typeof ListSupportSessionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_cortado_v1_admin, 0);

